<template>
  <div class="fullSize">
    <loading-page
        v-if="initialLoad && (loadingAlertTypes || loadingAlertStatistics)"
    ></loading-page>

    <default-page
        v-else-if="isUserNoAlertCards || isAdminNoAlertTypes"
        imageUrl="/img/dynamic-src-images/trade-watcher.svg"
        :title="$options.name"
        :text="emptyPageStateText"
        buttonText="Get Started"
        @button-clicked="
        isUserNoAlertCards ? createAlert() : getAlertTypes(true, true)
      "
        :noButtons="isUserNoAlertCards && !alertTypes.length"
    ></default-page>

    <v-container
        v-else
        class="pt-0 px-0"
        :class="
        $vuetify.breakpoint.smAndDown ? 'fix-overlays' : 'supplementary-class'
      "
        fluid
        :style="`width: 100%;height:${windowSizeY - 88}px !important;`"
    >
      <div v-if="isNotDesktop" class="navDraw-helper"></div>

      <confirm-dialog
          @confirmation-event="confirmationDialogEvent"
          @mutate-confirm-dialog="(value) => (this.confirmDialog = value)"
          :dialog="confirmDialog"
          :text="confirmationDialogText"
          acceptButton="Delete"
      ></confirm-dialog>

      <div
          v-if="$vuetify.breakpoint.mdAndUp"
          :class="{
              'tw-btn-container-left': $vuetify.breakpoint.mdAndUp,
              'tw-btn-container-left-mobile': $vuetify.breakpoint.smAndDown,
            }"
      >
        <v-menu :open-on-hover="!isNotDesktop" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
                v-show="showHistory"
                style="margin-top: 2px"
                :class="{ 'primary--text': historyFilter !== 'all' }"
                v-on="on"
                icon
                small
            >
              <v-icon style="font-size: 16px">fas fa-filter</v-icon>
            </v-btn>
          </template>

          <v-list dense class="py-0">
            <v-subheader
                @click.stop.prevent
            >
              Filter
            </v-subheader>
            <v-list-item
                v-for="filterItem in filters"
                :key="`filter-option-${filterItem.value}`"
                class="accent"
                @click="changeHistoryFilter(filterItem.value)"
            >
              <v-list-item-action class="ma-0">
                <v-icon
                    v-if="filterItem.value === 'all'"
                    :class="{ 'primary--text': historyFilter === 'all' }"
                    style="font-size: 14px"
                >fas fa-th
                </v-icon
                >
                <v-icon
                    v-else
                    :class="{ 'primary--text': filterItem.checked === true }"
                    style="font-size: 14px"
                >
                  {{
                    !!filterItem.checked ? 'far fa-check-circle' : 'far fa-circle'
                  }}
                </v-icon
                >
              </v-list-item-action>
              <v-list-item-title
                  :class="{ 'primary--text': !!filterItem.checked }"
              >{{ filterItem.label }}
              </v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
                v-show="showHistory"
                v-on="on"
                @click="toggleSorting"
                style="position: relative; margin-top: 2px; margin-left: 2px;"
                icon
                small
                color="primary"
            >
              <v-icon style="font-size: 16px; padding-left: 13px"
              >fas fa-clock
              </v-icon
              >
              <v-icon style="font-size: 16px; padding-right: 8px">{{
                  historySorting
                      ? "fas fa-long-arrow-alt-up"
                      : "fas fa-long-arrow-alt-down"
                }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{
              `Sort by time (${
                  historySorting === ALERT_SORTS.DESC ? "descending" : "ascending"
              })`
            }}</span>
        </v-tooltip>
      </div>
      <v-hover v-slot:default="{ hover }">
        <div>
          <v-badge
              :content="totalAlerts < 100 ? totalAlerts : '99+'"
              class="mt-4 mr-3 drawer-helper2 badge-shadow"
              style="z-index: 1"
          ></v-badge>
          <v-btn
              @click="
              $vuetify.breakpoint.smAndDown || isNotDesktop
                ? (issuesDrawer = true)
                : () => {}
            "
              color="primary"
              class="drawer-helper2"
              small
          >
            <v-icon
                v-if="$vuetify.breakpoint.mdAndUp"
                style="font-size: 16px; margin-right: 6px; margin-bottom: 1px"
            >fas fa-caret-left
            </v-icon
            >
            ALERTS
          </v-btn>

          <div
              v-if="!isNotDesktop"
              class="drawer-helper"
              style="z-index: 1"
          ></div>
          <div
              class="absolute"
              :class="
              alertDrawerMobile
                ? issuesDrawer
                  ? 'issues-action-drawer'
                  : 'issues-action-drawer-none'
                : hover
                ? 'issues-action-drawer'
                : 'issues-action-drawer-none'
            "
          >
            <v-list
                color="transparent"
                style="
                height: 100%;
                border-bottom: 1px solid gray;
                border-top: 1px solid gray;
              "
                dense
            >
              <div
                  id="active-issue-actions"
                  style="height: 100%; overflow-y: auto !important"
                  @scroll="
                  (ev) =>
                    syncScroll(
                      'active-issues',
                      'active-issue-actions',
                      alertCards.length,
                      ev,
                      0
                    )
                "
              >
                <div style="height: 1px; margin-top: 67px"></div>
                <v-list-item
                    v-for="alertDrawerCard in alertDrawerCards"
                    :key="alertDrawerCard.alertStatistics.alertCardId"
                    class="issuesActions-list"
                    style="max-height: 31px"
                >
                  <v-hover v-slot:default="{ hover }">
                    <div
                        :class="
                        alertDrawerCard.hovered || hover
                          ? 'issue-action'
                          : 'hide-issue-action pl-1'
                      "
                    >
                      <v-row>
                        <v-tooltip
                            :disabled="isNotDesktop"
                            class="mt-3 ml-1"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                style="height: 28px; width: 28px"
                                icon
                            >
                              <span
                                  @click="editAlertIssue(alertDrawerCard)"
                                  style="font-size: 28px"
                                  class="icon-edit-21x21"
                              >
                                <span class="path1 letterSpacing0"></span>
                                <span class="path2"></span>
                              </span>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip
                            :disabled="isNotDesktop"
                            class="mt-3 ml-1"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                                :disabled="!isAdmin"
                                v-on="on"
                                @click="
                                confirmDelete(
                                  alertDrawerCard.alertStatistics.alertCardId,
                                  alertDrawerCard.alertStatistics.name
                                )
                              "
                                style="height: 28px; width: 28px"
                                icon
                            >
                              <span
                                  :class="
                                  isAdmin
                                    ? 'icon-delete-21x21'
                                    : 'icon-delete-21x21-disabled'
                                "
                                  class="ml-1"
                                  style="font-size: 28px"
                              >
                                <span class="path1 letterSpacing0"></span>
                                <span class="path2"></span>
                              </span>
                            </v-btn>
                          </template>
                          <span>Delete alert card</span>
                        </v-tooltip>
                        <v-tooltip
                            :disabled="isNotDesktop"
                            class="mt-3 ml-1"
                            bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="confirmHistoryDelete(alertDrawerCard)"
                                style="
                                height: 28px;
                                width: 28px;
                                margin-left: 2px;
                              "
                                icon
                            >
                              <span
                                  class="ml-1 icon-delete-21x21"
                                  style="font-size: 28px"
                              >
                                <span class="path1 letterSpacing0"></span>
                                <span class="path2"></span>
                              </span>
                              <i
                                  class="fas fa-clock"
                                  style="
                                  font-size: 10px;
                                  position: absolute;
                                  top: 12px;
                                  right: 6px;
                                  background: #47bd96;
                                  border-radius: 10px;
                                "
                              ></i>
                            </v-btn>
                          </template>
                          <span
                          >Delete alert history
                            {{
                              selectedCard != null &&
                              $vuetify.breakpoint.mdAndUp
                                  ? `of ${selectedCard.name}`
                                  : ""
                            }}</span
                          >
                        </v-tooltip>
                      </v-row>
                    </div>
                  </v-hover>
                </v-list-item>
              </div>
            </v-list>
          </div>

          <!-- :key="alertsDrawerRenderKey" -->
          <alerts-drawer
              ref="alertsDrawer"
              :alertCards="alertDrawerCards"
              :isNotDesktop="isNotDesktop"
              :getAlertDrawerValue="getAlertDrawerValue(hover)"
              :alertDrawerClipped="alertDrawerClipped"
              @toggle-issues-drawer="(ev) => (issuesDrawer = ev)"
              @toggle-alert-drawer-clipped="clipAlertsDrawer"
              @create-alert="createAlert"
              @show-all-history="showAllHistory"
              @card-selected="cardSelected"
              @show-active-issue-actions="showAlertCardActions"
              @hide-active-issue-actions="hideAlertCardActions"
              @alert-card-action="
              alertCardAction(
                $event,
                !$event.alertStatistics.enabled
                  ? ALERT_CARD_ACTIONS.DISABLE
                  : ALERT_CARD_ACTIONS.ENABLE,
                'enabled'
              )
            "
          ></alerts-drawer>
        </div>
      </v-hover>
      <div
          v-if="$vuetify.breakpoint.mdAndUp"
          :class="{
              'tw-btn-container-right': $vuetify.breakpoint.mdAndUp,
              'tw-btn-container-right-mobile': $vuetify.breakpoint.smAndDown,
            }"
          :style="{
            marginRight: (($vuetify.breakpoint.mdAndUp && (alertDrawerClipped === true))) ? '148px' : 0
          }"
      >
        <ToggleDenseGrid :is-not-desktop="isNotDesktop" v-model="isDenseGrid"/>
        <v-tooltip :disabled="isNotDesktop" bottom>
          <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                text
                icon
                @click="$emit('mute-trade-watcher')"
                aria-label="volume"
                :class="{
                  'tw-mute-btn': $vuetify.breakpoint.mdAndUp,
                  'tw-mute-btn-mobile': $vuetify.breakpoint.smAndDown,
                  'tw-mute-show-history': showHistory,
                  'tw-mute-admin': isAdmin,
                }"
                style="margin-top: 2px;"
            >
              <v-icon v-if="tradeWatcherMute" color="grey">volume_off</v-icon>
              <v-icon v-else :color="$vuetify.theme.dark ? 'white' : 'grey'"
              >volume_up
              </v-icon
              >
            </v-btn>
          </template>
          <span> Mute Trade Watcher </span>
        </v-tooltip>
        <v-tooltip bottom v-if="isAdmin">
          <template v-slot:activator="{ on, attrs }">
            <div
                v-on="on"
                v-bind="attrs"
            >
              <data-transfer
                  :cards="alertCards"
                  :types="alertTypes"
                  @refresh="refresh"
              />
            </div>
          </template>
          <span>Data</span>
        </v-tooltip>
        <v-tooltip bottom v-if="isAdmin">
          <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                @click="getAlertTypes(true, true)"
                :class="
              $vuetify.breakpoint.mdAndUp
                ? 'tw-admin-btn'
                : 'tw-admin-btn-mobile'
            "
                icon
            >
              <v-icon style="font-size: 22px">icon-configurations-19x19</v-icon>
            </v-btn>
          </template>
          <span>Configure Alert Types</span>
        </v-tooltip>
      </div>
      <v-row
          justify="center"
          :class="{
          'pr-279px': alertDrawerClipped && $vuetify.breakpoint.mdAndUp,
        }"
          :style="
          $vuetify.theme.dark
            ? 'border-bottom: 1px solid #1C6E59;'
            : 'border-bottom: 1px solid #adadb2;'
        "
          style="height: 37px"
      >
        <div
            @click="switchTab(0)"
            :class="{ 'tw-tabs-wrap': $vuetify.breakpoint.width > 700 }"
            class="pl-3 my-auto"
            :style="
            $vuetify.breakpoint.width < 701
              ? 'height:20px !important;'
              : 'height:36px;'
          "
        >
          <p
              v-if="$vuetify.breakpoint.width > 700"
              class="mr-2 mb-0 secondary-h1"
              :class="{
              'black--text': !$vuetify.theme.dark && showHistory,
              'tw-clicked-tab': !showHistory,
            }"
              style="margin-top: 6px; font-size: 16px"
          >
            Alert Cards
          </p>
          <v-icon
              v-else
              small
              :class="{ 'tw-clicked-tab': !showHistory }"
              class="mb-1 mr-2"
              style="font-size: 19px"
          >
            fab fa-wpforms
          </v-icon>
        </div>
        <hr
            width="1"
            style="height: 20px; margin-top: 8px"
            :color="$vuetify.theme.dark ? 'grey' : 'primary'"
        />
        <!-- <v-btn small @click="rerenderAlertsDrawerComponent">Rerender drawer</v-btn> -->
        <div
            @click="switchTab(1)"
            :style="
            $vuetify.breakpoint.width < 701
              ? 'height:20px !important;'
              : 'height:36px;'
          "
            :class="{ 'tw-tabs-wrap': $vuetify.breakpoint.width > 700 }"
            class="pr-3 my-auto"
            style="height: 36px"
        >
          <p
              v-if="$vuetify.breakpoint.width > 700"
              class="ml-2 secondary-h1"
              :class="{
              'black--text': !$vuetify.theme.dark & !showHistory,
              'tw-clicked-tab': showHistory,
            }"
              style="margin-top: 6px; font-size: 16px"
          >
            History
            {{
              showingAllHistory
                  ? "of all"
                  : selectedCard != null && $vuetify.breakpoint.mdAndUp
                      ? ` of ${selectedCard.name}`
                      : ""
            }}
          </p>
          <v-icon
              v-else
              small
              :class="{ 'tw-clicked-tab': showHistory }"
              class="ml-2"
              style="margin-bottom: 5px; font-size: 18px"
          >
            fas fa-history
          </v-icon>
        </div>
      </v-row>
      <div v-if="$vuetify.breakpoint.smAndDown">
        <div
            class="tw-btn-container-mobile"
            :style="$vuetify.theme.dark ? 'background-color: rgba(250,250,250,0.1)' : 'background-color: rgba(0,0,0,0.1)'"
        >
          <v-menu :open-on-hover="!isNotDesktop" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                  v-show="showHistory"
                  style="margin-top: 2px"
                  :class="{ 'primary--text': historyFilter !== 'all' }"
                  v-on="on"
                  icon
                  small
              >
                <v-icon style="font-size: 16px">fas fa-filter</v-icon>
              </v-btn>
            </template>

            <v-list dense class="py-0">
              <v-subheader
                  @click.stop.prevent
              >
                Filter
              </v-subheader>
              <v-list-item
                  v-for="filterItem in filters"
                  :key="`filter-option-${filterItem.value}`"
                  class="accent"
                  @click="changeHistoryFilter(filterItem.value)"
              >
                <v-list-item-action class="ma-0">
                  <v-icon
                      v-if="filterItem.value === 'all'"
                      :class="{ 'primary--text': historyFilter === 'all' }"
                      style="font-size: 14px"
                  >fas fa-th
                  </v-icon
                  >
                  <v-icon
                      v-else
                      :class="{ 'primary--text': filterItem.checked === true }"
                      style="font-size: 14px"
                  >
                    {{
                      !!filterItem.checked ? 'far fa-check-circle' : 'far fa-circle'
                    }}
                  </v-icon
                  >
                </v-list-item-action>
                <v-list-item-title
                    :class="{ 'primary--text': !!filterItem.checked }"
                >{{ filterItem.label }}
                </v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                  v-show="showHistory"
                  v-on="on"
                  @click="toggleSorting"
                  style="position: relative; margin-top: 2px; margin-left: 2px;"
                  icon
                  small
                  color="primary"
              >
                <v-icon style="font-size: 16px; padding-left: 13px"
                >fas fa-clock
                </v-icon
                >
                <v-icon style="font-size: 16px; padding-right: 8px">{{
                    historySorting
                        ? "fas fa-long-arrow-alt-up"
                        : "fas fa-long-arrow-alt-down"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
                `Sort by time (${
                    historySorting === ALERT_SORTS.DESC ? "descending" : "ascending"
                })`
              }}</span>
          </v-tooltip>
          <v-spacer/>
          <ToggleDenseGrid :is-not-desktop="isNotDesktop" v-model="isDenseGrid"/>
          <v-tooltip :disabled="isNotDesktop" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                  v-on="on"
                  text
                  icon
                  @click="$emit('mute-trade-watcher')"
                  aria-label="volume"
                  :class="{
                  'tw-mute-btn': $vuetify.breakpoint.mdAndUp,
                  'tw-mute-btn-mobile': $vuetify.breakpoint.smAndDown,
                  'tw-mute-show-history': showHistory,
                  'tw-mute-admin': isAdmin,
                }"
                  style="margin-top: 2px;"
              >
                <v-icon v-if="tradeWatcherMute" color="grey">volume_off</v-icon>
                <v-icon v-else :color="$vuetify.theme.dark ? 'white' : 'grey'"
                >volume_up
                </v-icon
                >
              </v-btn>
            </template>
            <span> Mute Trade Watcher </span>
          </v-tooltip>
          <v-tooltip bottom v-if="isAdmin">
            <template v-slot:activator="{ on, attrs }">
              <div
                  v-on="on"
                  v-bind="attrs"
              >
                <data-transfer
                    :cards="alertCards"
                    :types="alertTypes"
                />
              </div>
            </template>
            <span>Data</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isAdmin">
            <template v-slot:activator="{ on, attrs }">
              <div
                  v-on="on"
                  v-bind="attrs"
              >
                <data-transfer
                    :cards="alertCards"
                    :types="alertTypes"
                    @refresh="refresh"
                />
              </div>
            </template>
            <span>Data</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isAdmin">
            <template v-slot:activator="{ on }">
              <v-btn
                  v-on="on"
                  @click="getAlertTypes(true, true)"
                  :class="
              $vuetify.breakpoint.mdAndUp
                ? 'tw-admin-btn'
                : 'tw-admin-btn-mobile'
            "
                  icon
              >
                <v-icon style="font-size: 22px">icon-configurations-19x19</v-icon>
              </v-btn>
            </template>
            <span>Configure Alert Types</span>
          </v-tooltip>
        </div>
      </div>
      <v-row justify="start" class="mx-0 fullSize">
        <v-row
            v-if="loadingAlertHistory && showHistory"
            style="width: 100%; height: 100%; align-content: center"
            justify="center"
        >
          <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </v-row>
        <div
            v-else
            id="alert-cards-wrapper"
            :class="alertContainerClasses"
            style="overflow-y: auto; overflow-x: hidden"
        >
          <v-row v-if="cards.length" class="mx-1">
            <v-col
                v-for="(card, i) in cards"
                :key="showHistory ? card.id : card.alertStatistics.alertCardId"
                :lg="getCardsLGLayout"
                :md="alertDrawerClipped ? 6 : 4"
                sm="6"
                cols="12"
                :class="isDenseGrid ? 'alert-card-wrap' : ''"
            >
              <v-lazy
                  :options="{
                  threshold: 0.1,
                }"
                  min-height="200"
                  transition="fade-transition"
                  :value="true"
              >
                <!-- IMPORTANT: value = true means DO NOT lazy load. Render right away. -->
                <!-- :value="!lazyLoadAlertCards" -->
                <!-- :value="lazyLoadAlertCards ? (i < 17 ? true : false) : true" -->
                <alert-card
                    :id="showHistory ? card.id : card.alertStatistics.alertCardId"
                    :showHistory="showHistory"
                    :cardInfo="showHistory ? card : card.alertStatistics"
                    :sourceNames="card.sourceNames"
                    :isNotDesktop="isNotDesktop"
                    :infoTabsProp="infoTabs"
                    :cardIndex="i"
                    @update:infoTabs="infoTabs = $event"
                    @card-selected="cardSelected"
                    @acknowledge="acknowledge"
                    @delete-history-card="deleteHistoryCard(card)"
                ></alert-card>
              </v-lazy>
            </v-col>
          </v-row>
          <v-row v-else class="mx-0 fullSize" justify="center">
            <v-col align-self="center">
              <v-row justify="center">
                <p style="color: #d4d4d4">
                  {{
                    showHistory ? getEmptyHistoryStateText : "No alert cards"
                  }}
                </p>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-row>

      <v-row
          v-show="!!showHistory"
          justify="space-between"
          justify-sm="end"
          :class="{
          'pr-279px': alertDrawerClipped && $vuetify.breakpoint.mdAndUp,
          'tw-footer-touchscreen': isNotDesktop,
          'tw-footer': !isNotDesktop,
        }"
          class="mx-0"
      >
        <div
            style="
            height: 44px;
            display: flex;
            align-items: center;
            font-size: 0.75rem;
          "
            class="ml-2"
        >
          <div
              v-if="$vuetify.breakpoint.smAndUp"
              :class="{ 'grey--text': !showHistory }"
              class="mr-6"
          >
            Rows per page:
          </div>
          <div
              :class="{ 'mr-1': $vuetify.breakpoint.smAndUp }"
              class="footer-items-wrapper"
          >
            <v-select
                dense
                :disabled="!showHistory"
                class="footer-items-per-page mt-0"
                hide-details
                :menu-props="{ top: true, offsetY: true }"
                :items="[10, 25, 50, 100]"
                v-model="itemsPerPage"
                @change="paginationChangeHandler(1)"
            ></v-select>
          </div>
        </div>
        <div>
          <v-pagination
              @input="paginationChangeHandler"
              :key="paginationRenderKey"
              :value="page"
              :length="totalPages"
              :total-visible="$vuetify.breakpoint.xsOnly ? 5 : 7"
              circle
              class="pagination"
          ></v-pagination>
        </div>
      </v-row>

      <v-dialog
          v-model="queryDialog"
          width="683"
          overlay-color="grey darken-2"
          transition="scroll-x-transition"
          persistent
      >
        <v-card style="max-width: 750px; min-height: 200px" color="accent">
          <v-card-title dark style="background-color: #47bd96; color: white">
            Query Editor
          </v-card-title>

          <v-row justify="center" class="mx-0">
            <v-col cols="12" class="pa-4 pb-0">
              <div
                  class="formatted-query-wrapper"
                  style="border: 1px solid #9fa6bf; border-radius: 4px"
              >
                <v-textarea
                    v-model="formattedQuery"
                    class="formatted-query"
                    role="textbox"
                    :min-height="400"
                >
                </v-textarea>
              </div>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-btn @click="formatQuery()" text color="primary">
              <v-icon small class="mr-1"> fas fa-magic</v-icon>
              Format
            </v-btn
            >
            <v-btn
                @click="showFormatSettings = !showFormatSettings"
                class="ml-0 mb-1 mr-1"
                icon
            >
              <v-icon :color="showFormatSettings ? 'primary' : 'white'" small>
                fas fa-cog
              </v-icon>
            </v-btn>
            <div v-if="showFormatSettings">Spaces</div>
            <div v-if="showFormatSettings" class="ml-2" style="width: 30px">
              <v-text-field
                  v-model.number="querySpaces"
                  type="number"
                  dense
                  class="mt-1"
              ></v-text-field>
            </div>
            <v-spacer></v-spacer>
            <v-btn @click="queryDialog = !queryDialog" text>cancel</v-btn>
            <v-btn @click="acceptQueryFormat" text color="primary">ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-dialog
        v-model="twAdminDialog"
        width="750"
        overlay-color="grey darken-2"
        transition="scroll-x-transition"
        content-class="d-dialog-panel"
        persistent
    >
      <v-card style="max-width: 750px" class="insideRows-no-mx" color="accent">
        <v-card-title
            style="
            background-color: #47bd96;
            color: white;
            letter-spacing: 0.03rem;
          "
            :style="
            $vuetify.breakpoint.xsOnly ? 'text-align: center !important;' : ''
          "
        >Configure Alert Types
        </v-card-title
        >
        <v-form ref="adminForm" v-model="adminForm">
          <v-row class="mx-1" style="overflow-y: auto; max-height: 780px">
            <v-col cols="12">
              <p
                  class="pb-0"
                  style="
                  font-size: 16px;
                  font-weight: 400;
                  letter-spacing: 0.03rem;
                "
              >
                Types
              </p>
              <v-simple-table
                  dense
                  fixed-header
                  style="
                  border-radius: 6px 6px 0 0;
                  max-height: 206px;
                  overflow-y: auto;
                "
                  class="stylish-text typesTable mx-2"
              >
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th
                        style="border-radius: 6px 6px 0 0"
                        class="text-left typesTable"
                    >
                      Name
                    </th>
                    <th
                        style="border-radius: 6px 6px 0 0"
                        class="text-left typesTable"
                    >
                      Description
                    </th>
                    <th
                        style="
                          border-radius: 6px 6px 0 0;
                          text-align: center !important;
                        "
                        class="text-left typesTable"
                    >
                      Actions
                    </th>
                  </tr>
                  </thead>
                  <td colspan="3" v-if="!alertTypes.length" style="width: 100%">
                    <p
                        class="text-center mt-5 mb-0"
                        style="color: rgb(255, 255, 255, 0.5)"
                    >
                      No alert types yet
                    </p>
                  </td>
                  <tbody v-else>
                  <tr
                      v-for="alertType in alertTypes"
                      :key="alertType.id"
                      :class="
                        alertTypeEditing && alertType.id === alertTypeEditing.id
                          ? 'types-table-item-selected'
                          : 'types-table-item-unselected types-table-item'
                      "
                  >
                    <td
                        class="clickableText"
                        @click="editAlertType(alertType)"
                    >
                      <v-row>
                        {{ alertType.name }}
                      </v-row>
                    </td>
                    <td
                        class="clickableText"
                        @click="editAlertType(alertType)"
                    >
                      {{ alertType.description }}
                    </td>
                    <td>
                      <v-row justify="center" style="min-width: 72px">
                        <v-btn @click="deleteAlertType(alertType)" icon>
                            <span
                                style="font-size: 28px"
                                class="icon-delete-21x21"
                            >
                              <span class="path1 letterSpacing0"></span>
                              <span
                                  class="path2"
                                  style="margin-left: -1px"
                              ></span>
                            </span>
                        </v-btn>

                        <v-badge
                            offset-x="16"
                            offset-y="12"
                            :class="{ 'badge-small': alertType.unsaved }"
                            :value="alertType.unsaved || false"
                            :key="unsavedMsgRenderKey"
                            color="red"
                            icon="fas fa-exclamation"
                        >
                        </v-badge>
                      </v-row>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-row justify="start" class="typesTable mx-2">
                <v-btn
                    @click="addAlertType"
                    text
                    class="mt-2 ml-0"
                    color="primary"
                    style="font-size: 14px"
                >
                  <i style="color: #47bd96" class="fas fa-plus-circle mr-1"></i
                  >Add type
                </v-btn>
              </v-row>
            </v-col>
            <v-col
                cols="12"
                v-if="alertTypeEditing != null && alertTypes.length"
            >
              <v-row
                  style="
                  font-size: 16px;
                  font-weight: 400;
                  letter-spacing: 0.03rem;
                "
              >
                {{ alertTypeEditing.name }}
                <p
                    :key="unsavedMsgRenderKey"
                    style="
                    margin-bottom: -2px;
                    margin-top: 2px;
                    color: #d32f2f;
                    font-size: 15px;
                    font-weight: 400;
                  "
                    class="ml-3"
                >
                  {{ alertTypeEditing.unsaved ? "(Unsaved)" : "" }}
                </p>
              </v-row>
              <v-tabs
                  v-model="alertTypeTabs"
                  centered
                  hide-slider
                  background-color="accent"
              >
                <v-tab @click="updateMessageFormat" active-class="primary--text"
                >Settings
                </v-tab
                >
                <v-tab active-class="primary--text">Appearance</v-tab>
                <!-- <v-tab active-class="primary--text">Card Info</v-tab> -->

                <v-tabs-items v-model="alertTypeTabs" class="accent">
                  <v-tab-item>
                    <v-row justify="center" class="pt-4">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-text-field
                            v-model="alertTypeEditing.name"
                            dense
                            outlined
                            label="Name"
                            @input="hasChanges = true"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-text-field
                            v-model="alertTypeEditing.description"
                            dense
                            outlined
                            label="Description"
                            @input="hasChanges = true"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-text-field
                            v-model="alertTypeEditing.query"
                            dense
                            outlined
                            label="Query"
                            @input="hasChanges = true"
                        >
                          <template v-slot:append>
                            <v-row style="margin-top: -3px">
                              <v-icon
                                  @click="openQueryDialog"
                                  small
                                  color="primary"
                              >fas fa-expand
                              </v-icon
                              >
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                      v-on="on"
                                      @click="modifyQueryValidation"
                                      icon
                                      small
                                      style="
                                      margin-right: -4px !important;
                                      margin-left: 2px !important;
                                    "
                                  >
                                    <v-icon
                                        :key="queryValidationRenderKey"
                                        small
                                        :color="
                                        alertTypeEditing.skipQueryValidation
                                          ? 'white'
                                          : 'primary'
                                      "
                                    >fas fa-spell-check
                                    </v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span :key="queryValidationRenderKey"
                                >Query validation:
                                  <b>{{
                                      alertTypeEditing.skipQueryValidation
                                          ? "OFF"
                                          : "ON"
                                    }}
                                  </b>
                                  {{
                                    !alertTypeEditing.skipQueryValidation
                                        ? " (default)"
                                        : ""
                                  }}
                                  <br>
                                  Validate the query for any mistakes when saving the alert type
                                  </span
                                  >
                              </v-tooltip>
                            </v-row>
                            <!-- <v-checkbox
                            class="aggregated-checkbox mt-0 ml-5"
                            v-model="alertTypeEditing.skipQueryValidation"
                            small
                            dense
                            label="Skip query validation"
                            style="font-size: 8px !important"
                          ></v-checkbox> -->
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-text-field
                            v-model="alertTypeEditing.scope"
                            dense
                            outlined
                            label="Scope"
                            @input="hasChanges = true"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="12" sm="6" class="py-0">
                        <v-select
                            outlined
                            dense
                            :menu-props="{
                            offsetY: true,
                            maxHeight: '250',
                          }"
                            :label="
                            alertTypeEditing.arguments.length
                              ? `Metric Arguments: ${alertTypeEditing.arguments.length}`
                              : 'No arguments yet'
                          "
                            no-data-text="No arguments yet"
                            v-model="selectedATArgument"
                            :items="alertTypeEditing.arguments"
                            return-object
                            item-text="friendlyName"
                            item-value="id"
                            @input="hasChanges = true"
                        >
                          <template v-slot:prepend-item>
                            <v-list-item
                                @click="addNewMetricArgument"
                                style="
                                max-height: 40px;
                                border-bottom: 1px solid #7f7f7f;
                              "
                                ripple
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                    style="
                                    font-size: 14px !important;
                                    font-weight: 400;
                                  "
                                >
                                  <i
                                      style="color: #47bd96"
                                      class="fas fa-plus-circle mr-1"
                                  ></i>
                                  New argument
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="6" class="py-0">
                        <v-row>
                          <v-checkbox
                              class="aggregated-checkbox mt-0"
                              v-model="alertTypeEditing.isDistributedQuery"
                              small
                              dense
                              label="Aggregated"
                              style="font-size: 8px !important"
                              @input="hasChanges = true"
                          ></v-checkbox>
                        </v-row>
                      </v-col>
                    </v-row>
                    <div
                        v-if="selectedATArgument.id > -1"
                        style="border: 1px solid #47bd96; border-radius: 4px"
                        class="mx-2"
                    >
                      <div
                          class="pl-3 mt-1"
                          style="
                          font-size: 16px;
                          letter-spacing: 0.03rem;
                          color: #47bd96;
                        "
                          justify="space-between"
                      >
                        <p>{{ selectedATArgument.name }}</p>
                      </div>
                      <v-row>
                        <v-col cols="6" class="pt-2">
                          <v-text-field
                              outlined
                              class="mt-0 dense-text-fields"
                              dense
                              style="height: 40px"
                              label="Name"
                              v-model="selectedATArgument.name"
                              @input="hasChanges = true"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pt-2">
                          <v-text-field
                              outlined
                              class="mt-0 dense-text-fields"
                              dense
                              style="height: 40px"
                              label="Friendly Name"
                              :rules="[rules.required]"
                              v-model="selectedATArgument.friendlyName"
                              @input="hasChanges = true"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pt-2">
                          <v-select
                              label="Type"
                              dense
                              style="height: 40px"
                              class="mt-0 dense-text-fields"
                              outlined
                              :menu-props="{ offsetY: true, maxHeight: '250' }"
                              :items="[
                              'number',
                              'double',
                              'array (string)',
                              'array (number)',
                              'boolean',
                            ]"
                              v-model="selectedATArgument.type"
                              @input="hasChanges = true"
                          ></v-select>
                        </v-col>

                        <v-col cols="6" class="pt-2">
                          <v-text-field
                              outlined
                              class="mt-0 dense-text-fields"
                              dense
                              style="height: 40px"
                              :label="
                              this.selectedATArgument.type === 'boolean'
                                ? 'Description'
                                : 'Metric Unit'
                            "
                              v-model="selectedATArgument.metricUnit"
                              @input="hasChanges = true"
                          ></v-text-field>
                        </v-col>

                        <v-col v-if="isDoubleOrNumber" cols="6" class="pt-2">
                          <v-text-field
                              outlined
                              class="mt-0 dense-text-fields"
                              dense
                              style="height: 40px"
                              label="Min"
                              v-model.number="selectedATArgument.min"
                              @input="hasChanges = true"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="isDoubleOrNumber" cols="6" class="pt-2">
                          <v-text-field
                              outlined
                              class="mt-0 dense-text-fields"
                              dense
                              style="height: 40px"
                              label="Max"
                              v-model.number="selectedATArgument.max"
                              @input="hasChanges = true"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="isDoubleOrNumber" cols="6" class="pt-2">
                          <v-text-field
                              outlined
                              class="mt-0 dense-text-fields"
                              dense
                              :hint="getStepHint"
                              style="height: 40px"
                              label="Step"
                              v-model.number="selectedATArgument.step"
                              @input="hasChanges = true"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="isDoubleOrNumber" cols="6" class="pt-2">
                          <v-checkbox
                              class="aggregated-checkbox mt-0 ml-2"
                              small
                              dense
                              label="Force other value"
                              style="font-size: 8px !important"
                              v-model="selectedATArgument.plainValueOnly"
                              @change="hasChanges = true"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row justify="end">
                        <v-btn @click="deleteATArgument" color="red" text
                        >delete
                        </v-btn
                        >
                      </v-row>
                    </div>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row>
                      <v-col cols="0" sm="1"></v-col>
                      <v-col cols="12" sm="5">
                        <v-text-field
                            dense
                            outlined
                            placeholder="Column Name"
                            v-model="alertTypeEditing.message.columnNames"
                            hide-details
                            label="Column names e.g Login,Equity"
                            class="analyticsTextFieldClass mx-auto"
                            style="margin-bottom: 8px; max-width: 250px"
                            @input="hasChanges = true"
                        ></v-text-field>
                        <v-text-field
                            class="analyticsTextFieldClass mx-auto"
                            dense
                            outlined
                            placeholder="Column Name"
                            hide-details
                            v-model="alertTypeEditing.message.columnNumbers"
                            label="Column numbers e.g 2,5,1"
                            style="max-width: 250px"
                            @input="hasChanges = true"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="5" class="py-3">
                        <div class="mx-auto" style="max-width: 265px">
                          <div
                              style="
                              border-radius: 12px;
                              font-size: 12.5px;
                              max-width: 265px;
                            "
                              class="pt-1 mx-2 pr-2 notification-history-section"
                          >
                            <v-row class="ma-0 pl-2" style="padding-top: 2px">
                              <p
                                  class="mb-0 ml-1"
                                  style="letter-spacing: 0.6px"
                              >
                                Trade Watcher
                              </p>
                              <div class="mx-1">-</div>
                              <p
                                  style="
                                  font-size: 11px;
                                  letter-spacing: 0.08rem;
                                  margin-top: 2px;
                                "
                                  class="mb-0"
                              >
                                {{ alertTypeEditing.name }}
                              </p>
                            </v-row>
                            <v-row class="ma-0">
                              <v-icon
                                  class="pl-1 mb-4"
                                  color="red"
                                  style="
                                  float: left;
                                  font-size: 14px;
                                  margin: 8px;
                                  margin-left: 9px;
                                  margin-top: 9px;
                                "
                              >fas fa-exclamation-triangle
                              </v-icon
                              >

                              <span
                                  id="alert-appearance-text"
                                  role="textbox"
                                  style="
                                  max-width: 155px;
                                  float: left;
                                  margin: 4px 0 4px 4px;
                                  font-size: 11px;
                                "
                                  contenteditable
                                  @input="hasChanges = true"
                              >
                                {{ alertTypeEditing.message.format }}
                              </span>
                            </v-row>
                          </div>
                          <div
                              style="text-align: end; font-size: 10.5px"
                              class="mr-5"
                          >
                            11:00
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="0" sm="1"></v-col>
                    </v-row>
                  </v-tab-item>
                  <!-- <v-tab-item style="font-size: 14px !important;">
                    <v-row justify="center" class="py-3">
                      <v-card
                        class="accent"
                        style="max-width:350px;min-width:350px;"
                      >
                        <v-card-title class="primary">
                          {{ alertTypeEditing.name }}
                        </v-card-title>
                        <div>
                          <v-row
                            v-for="infoItem in cardInfoArray"
                            :key="infoItem.id"
                            class="card-info-row"
                          >
                            <div class="card-info-row-actions ml-1">
                              <v-icon
                                @click="deleteInfoItem(infoItem.id)"
                                class="red--text mr-1"
                                small
                                >fas fa-minus-circle</v-icon
                              >
                              <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" class="primary--text" small
                                    >fas fa-plus-circle</v-icon
                                  >
                                </template>

                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      @click="openCardInfoOptionDialog"
                                      small
                                      class="square-btn"
                                      color="#313a3d"
                                    >
                                      <v-icon small>far fa-clone</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Tabs</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      class="square-btn"
                                      color="#313a3d"
                                      v-on="on"
                                      small
                                    >
                                      K/V
                                    </v-btn>
                                  </template>
                                  <span>Key/Value</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      class="square-btn"
                                      color="#313a3d"
                                      v-on="on"
                                      small
                                    >
                                      <v-icon small>fas fa-table</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Table</span>
                                </v-tooltip>
                              </v-menu>
                            </div>
                            <div class="ml-4 mb-0 mt-3">
                              {{ infoItem.text }}&nbsp; {{ infoItem.id }}
                            </div>
                          </v-row>
                        </div>
                      </v-card>
                    </v-row>
                  </v-tab-item> -->
                </v-tabs-items>
              </v-tabs>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions class="pa-0">
          <v-btn
              @click="closeAlertTypeEditor"
              text
              color="primary"
              class="mb-2 ml-2"
          >
            Close
          </v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
              @click="saveAlertTypeHandler"
              text
              color="primary"
              class="mb-2 mr-2"
              :disabled="!hasChanges"
              :loading="alertTypeActionLoading"
          >
            Save Type
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        overlay-color="grey darken-2"
        transition="scroll-x-transition"
        width="700"
        v-model="dialog"
        persistent
    >
      <v-card
          class="accent"
          style="max-width: 700px; overflow-y: hidden !important"
      >
        <v-card-title
            v-if="edit"
            style="background-color: #47bd96; color: white"
            :style="
            $vuetify.breakpoint.xsOnly ? 'text-align: center !important;' : ''
          "
            class="pageTitle"
            :class="{
            'TW-dialog-title': $vuetify.breakpoint.xsOnly || isNotDesktop,
          }"
        >
          <p class="char-lim mx-0 mt-0 pb-3">{{ currentEditIssue.name }}</p>
          <p v-if="(!!currentEditIssue.alertType) && !!currentEditIssue.alertType.name &&(currentEditIssue.alertType.name.length > 0)"
             class="ml-1">{{ "(" + currentEditIssue.alertType.name + ")" }}</p>
        </v-card-title>
        <v-card-title
            v-else
            style="background-color: #47bd96; color: white"
            :style="
            $vuetify.breakpoint.xsOnly ? 'text-align: center !important;' : ''
          "
            class="pageTitle"
        >New Alert
        </v-card-title
        >
        <div v-if="!edit">
          <v-stepper
              v-model="wizard"
              flat
              vertical
              :style="`max-height: ${
              $vuetify.breakpoint.height - 200
            }px;overflow-y:auto;`"
          >
            <v-stepper-step :complete="wizard > 1" step="1">
              Alert {{ newAlert.name ? ": " + newAlert.name : "" }}
              {{
                selectedAlertType.name ? "(" + selectedAlertType.name + ")" : ""
              }}
            </v-stepper-step>

            <v-stepper-content step="1">
              <v-form ref="newAlertForm" v-model="validForm1">
                <v-row justify="center" class="pt-1">
                  <v-col class="py-0" cols="11" sm="6">
                    <v-textarea
                        autofocus
                        outlined
                        v-model="newAlert.name"
                        role="textbox"
                        label="Name"
                        dense
                        class="dense-textarea"
                        :min-height="30"
                        :rules="[alertRules.required]"
                        @keypress="keyPressed"
                    >
                    </v-textarea>
                  </v-col>
                  <v-col class="py-0" cols="11" sm="6">
                    <v-textarea
                        outlined
                        v-model="newAlert.description"
                        role="textbox"
                        label="Description"
                        dense
                        class="dense-textarea"
                        :min-height="30"
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
                <v-row
                    :justify="$vuetify.breakpoint.xsOnly ? 'center' : 'start'"
                >
                  <v-col class="py-0" cols="11" sm="6">
                    <v-select
                        v-model="selectedAlertType"
                        :menu-props="{ offsetY: true, maxHeight: '250' }"
                        outlined
                        dense
                        color="primary"
                        :items="alertTypes"
                        item-text="name"
                        return-object
                        label="Choose Alert Type"
                        @change="
                        newAlert.name.length && newAlert.sourceIds.length
                          ? wizardContinue()
                          : () => {}
                      "
                        :rules="[alertRules.requiredObject]"
                    >
                      <template v-slot:item="{ item }">
                        {{ item.name }}
                        <v-spacer></v-spacer>
                        <v-tooltip content-class="opaque-tooltip" bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">far fa-question-circle</v-icon>
                          </template>
                          <span>{{ item.description }}</span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col class="py-0" cols="11" sm="6">
                    <v-select
                        multiple
                        v-model="newAlert.sourceIds"
                        :menu-props="{ offsetY: true, maxHeight: '250' }"
                        outlined
                        dense
                        color="primary"
                        :items="availableServers"
                        item-text="name"
                        item-value="id"
                        label="Choose Servers"
                        persistent-hint
                        :rules="[alertRules.requiredServer]"
                    >
                      <template v-slot:prepend-item>
                        <v-list-item
                            style="
                            max-height: 40px;
                            border-bottom: 1px solid #7f7f7f;
                          "
                            ripple
                            @click="selectAllServers('newAlert')"
                        >
                          <v-list-item-content>
                            <v-list-item-title
                                :class="
                                newAlert.sourceIds.length ===
                                availableServers.length
                                  ? 'primary--text'
                                  : $vuetify.theme.dark
                                  ? 'white--text'
                                  : 'black--text'
                              "
                                style="
                                font-size: 16px !important;
                                font-weight: 400;
                              "
                            >
                              {{
                                (newAlert?.sourceIds?.length === availableServers?.length) ? 'Deselect All' : 'Select All'
                              }}
                            </v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-slot:item="{ item }">
                        {{ item.name }}
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span
                            v-if="index === 0"
                            :class="{
                            'v-select-char-lim': newAlert.sourceIds.length > 1,
                          }"
                            class="mr-1"
                        >{{ item.name }}</span
                        >
                        <span v-if="index === 1">
                          (+{{ newAlert.sourceIds.length - 1 }}
                          others)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <v-stepper-step :complete="wizard > 2" step="2"
            >Settings
            </v-stepper-step
            >

            <v-stepper-content step="2">
              <v-form ref="TWForm2" v-model="validForm2">
                <div v-if="selectedAlertType.arguments && wizard > 1">
                  <div
                      v-for="(
                      alertTypeArgument, i
                    ) in selectedAlertType.arguments"
                      :key="i"
                  >
                    <v-row justify="space-between">
                      <p class="pb-0 pl-5">
                        {{ alertTypeArgument.friendlyName }}
                        {{
                          alertTypeArgument.metricUnit
                              ? "(" + alertTypeArgument.metricUnit + ")"
                              : ""
                        }}
                      </p>
                      <v-checkbox
                          v-if="
                          (alertTypeArgument.type === 'double' ||
                            alertTypeArgument.type === 'number') &&
                          !alertTypeArgument.plainValueOnly &&
                          !!newAlert.arguments
                        "
                          class="pb-2 pr-5 small-checkbox"
                          v-model="
                          newAlert.arguments[alertTypeArgument.name].customValue
                        "
                          @change="updateVue"
                          small
                          dense
                          label="Other value"
                          style="font-size: 8px !important"
                      ></v-checkbox>
                    </v-row>
                    <v-row
                        v-if="
                        !!newAlert.arguments && (newAlert.arguments[alertTypeArgument.name]
                          .customValue || alertTypeArgument.plainValueOnly)
                      "
                        style="margin-top: -12px"
                        class="pl-5"
                    >
                      <v-col class="py-0 pl-5" cols="11" sm="6">
                        <v-text-field
                            outlined
                            dense
                            v-model.number="
                            newAlert.arguments[alertTypeArgument.name].value
                          "
                            type="number"
                            :rules="constructRules(newAlert.arguments[alertTypeArgument.name].value, alertTypeArgument.min, alertTypeArgument.max, true)"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row
                        v-else-if="(alertTypeArgument.type === 'double' ||
                        alertTypeArgument.type === 'number')"
                        style="margin-top: -12px"
                        class="pl-5"
                    >
                      <v-slider
                          v-if="(
                            (alertTypeArgument.max !== null) && !!alertTypeArgument.step
                        )
                      "
                          :min="Number(alertTypeArgument.min) || 0"
                          :max="Number(alertTypeArgument.max)"
                          ticks="always"
                          tick-size="2"
                          :step="Number(alertTypeArgument.step)"
                          thumb-label="always"
                          class="px-5"
                          :class="
                        alertTypeArgument.max / alertTypeArgument.step > 100
                          ? 'slider-ticks-many'
                          : 'slider-ticks-few'
                      "
                          style="text-align: center; margin: auto"
                          v-model="newAlert.arguments[alertTypeArgument.name].value"
                          :rules="constructRules(newAlert.arguments[alertTypeArgument.name].value, alertTypeArgument.min, alertTypeArgument.max, false)"
                      >
                        <template v-slot:thumb-label="{ value }">
                          <div class="pt-1 ec-slider"
                               :style="sliderStyle(newAlert.arguments[alertTypeArgument.name].value)">
                            {{ value }}
                          </div>
                        </template>
                      </v-slider>
                      <v-col v-else class="py-0 pl-5" cols="11" sm="6">
                        <v-text-field
                            outlined
                            dense
                            v-model.number="
                            newAlert.arguments[alertTypeArgument.name].value
                          "
                            type="number"
                            :rules="constructRules(newAlert.arguments[alertTypeArgument.name].value, alertTypeArgument.min, alertTypeArgument.max, true)"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row
                        v-else-if="alertTypeArgument.type === 'boolean'"
                        class="pl-5"
                    >
                      <v-checkbox
                          v-if="!!newAlert.arguments[alertTypeArgument.name]"
                          class="pb-2 pr-5 small-checkbox"
                          v-model="
                          newAlert.arguments[alertTypeArgument.name].value
                        "
                          @change="updateVue"
                          small
                          dense
                          label="Yes / No"
                          style="font-size: 8px !important"
                      ></v-checkbox>
                    </v-row>
                    <v-row v-else class="pl-5">
                      <v-col cols="11" sm="6" class="pl-5">
                        <v-textarea
                            v-if="!!newAlert.arguments[alertTypeArgument.name]"
                            outlined
                            v-model="
                            newAlert.arguments[alertTypeArgument.name].value
                          "
                            role="textbox"
                            placeholder="..."
                            dense
                            class="dense-textarea"
                            :min-height="30"
                            :rules="
                            alertTypeArgument.type === 'array (number)'
                              ? [alertRules.containNumber]
                              : [alertRules.required]
                          "
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-form>
            </v-stepper-content>
            <v-stepper-step :complete="wizard > 3" step="3"
            >Importance & Timing
            </v-stepper-step
            >

            <v-stepper-content step="3">
              <v-form ref="TWForm3" v-model="validForm3">
                <p>Notification Type</p>
                <v-row style="margin-top: -26px" class="pl-5 mt-2 mb-4">
                  <v-col cols="11" sm="6">
                    <specifications
                        ref="specificationsPanel"
                        v-model="newAlert.specifications.dynamicThreshold"
                        :type="newAlert.notificationType"
                        :options="alertImportance"
                        @change-type="changeNotificationTypeHandler"
                        @change-settings="changeNotificationSettingsHandler"
                    />
                  </v-col>
                </v-row>
                <p>Alert Timing</p>
                <p class="pr-11 text-center" style="font-size: 16px">
                  Select Days ({{
                    Object.keys(newAlert.daysOfWeek).filter(
                        (el) => newAlert.daysOfWeek[el].value
                    ).length
                  }})
                </p>
                <v-row class="days-of-week">
                  <v-col cols="12">
                    <v-row justify="center" class="mr-7">
                      <div
                          class="days-wrap"
                          v-for="day in Object.keys(newAlert.daysOfWeek)"
                          :key="day"
                      >
                        <v-btn
                            text
                            v-model="newAlert.daysOfWeek[day].value"
                            @click="selectDay(day)"
                            class="one-color day"
                            :class="
                            newAlert.daysOfWeek[day].value
                              ? 'selected-day'
                              : 'supplementary-class'
                          "
                            color="white"
                            hide-details
                        >
                          <template v-slot:default>
                            <p class="mb-0">
                              <span style="display: block">{{ day }}</span>
                              <span
                                  v-if="newAlert.daysOfWeek[day]"
                                  style="color: gray !important; font-size: 11px"
                              >{{ getDayTime(day) }}</span
                              >
                            </p>
                          </template>
                        </v-btn>
                        <div
                            style="
                            width: 68px;
                            height: 20px;
                            padding-bottom: 25px;
                            margin-top: -5px;
                          "
                            class="text-center day-edit-wrapper"
                            :class="
                            newAlert.daysOfWeek[day].value
                              ? 'selected-day'
                              : 'supplementary-class'
                          "
                        >
                          <v-btn
                              @click="currentDayEditing = day"
                              dense
                              x-small
                              width="22"
                              height="22"
                              icon
                              :class="{
                              'selected-day': newAlert.daysOfWeek[day].value,
                            }"
                          >
                            <v-icon style="font-size: 14px; margin-left: 1px"
                            >far fa-clock
                            </v-icon
                            >
                          </v-btn>
                        </div>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row justify="center" class="pt-5" style="margin-right: 32px">
                  <p style="margin-bottom: -10px">
                    {{ daysOfWeek[currentDayEditing] }}
                  </p>
                </v-row>
                <v-row
                    v-if="newAlert.daysOfWeek[this.currentDayEditing]"
                    justify="center"
                    class="mr-8"
                >
                  <v-col
                      class="pt-6 px-0"
                      :style="
                      !$vuetify.breakpoint.xsOnly
                        ? 'margin-left:12px;height:76px;width:40px;text-align:center;'
                        : 'height:40px;width:40px;text-align:center;'
                    "
                  >
                    <p style="position: relative; top: 35%" class="mb-5">
                      From
                    </p>
                  </v-col>
                  <v-col cols="11" sm="4">
                    <v-row justify="center" align="center">
                      <v-text-field
                          style="max-width: 35px"
                          dense
                          v-model.number="fromHour"
                          @input="(value) => timeChanged(value, 'from', 'hours')"
                          class="pt-0 my-0 no-underline align-center"
                          type="number"
                          :min="minHour"
                          :max="maxHour"
                          step="1"
                          required
                          hide-details
                      ></v-text-field
                      >
                      :
                      <v-text-field
                          style="max-width: 35px"
                          dense
                          v-model="fromMinute"
                          @input="
                          (value) => timeChanged(value, 'from', 'minutes')
                        "
                          class="pt-0 my-0 no-underline align-center"
                          type="number"
                          :min="minMinute"
                          :max="maxMinute"
                          step="1"
                          required
                          hide-details
                      ></v-text-field>
                      <v-select
                          class="dayPeriods"
                          style="max-width: 35px !important; margin-left: 4px"
                          v-model="
                          newAlert.daysOfWeek[currentDayEditing].time.from
                            .dayPeriod
                        "
                          :items="dayPeriods"
                      ></v-select>
                    </v-row>
                  </v-col>
                  <v-col
                      v-if="!$vuetify.breakpoint.xsOnly"
                      style="height: 76px; width: 20px; text-align: center"
                  >
                    <p style="position: relative; top: 50%">-</p>
                  </v-col>
                  <v-col
                      :style="
                      !$vuetify.breakpoint.xsOnly
                        ? 'height:76px;width:40px;text-align:center;'
                        : 'height:40px;width:40px;text-align:center;'
                    "
                  >
                    <p style="position: relative; top: 50%">To</p>
                  </v-col>
                  <v-col
                      style="height: 76px !important"
                      cols="11"
                      sm="4"
                      class="pb-0 pt-3"
                  >
                    <v-row class="mx-0" justify="center" align="center">
                      <v-text-field
                          style="max-width: 35px"
                          dense
                          v-model="toHour"
                          @input="(value) => timeChanged(value, 'to', 'hours')"
                          class="pt-0 my-0 no-underline align-center"
                          type="number"
                          :min="minHour"
                          :max="maxHour"
                          step="1"
                          required
                          hide-details
                      ></v-text-field
                      >
                      :
                      <v-text-field
                          style="max-width: 35px"
                          dense
                          v-model="toMinute"
                          @input="(value) => timeChanged(value, 'to', 'minutes')"
                          class="pt-0 my-0 no-underline align-center"
                          type="number"
                          :min="minMinute"
                          :max="maxMinute"
                          step="1"
                          required
                          hide-details
                      ></v-text-field>
                      <v-select
                          class="dayPeriods"
                          style="max-width: 35px !important; margin-left: 4px"
                          v-model="
                          newAlert.daysOfWeek[currentDayEditing].time.to
                            .dayPeriod
                        "
                          :items="dayPeriods"
                      ></v-select>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>
          </v-stepper>
        </div>
        <div
            v-else
            id="top-scrolls"
            :style="`max-height: ${
            $vuetify.breakpoint.height - 270
          }px; overflow-y:auto;overflow-x:hidden;`"
        >
          <div v-if="currentEditIssue.arguments">
            <v-form v-model="editValidForm" class="pt-2" ref="TWEditForm">
              <v-row class="mx-0">
                <p class="pb-0 pl-5 alert-editor-label">Name</p>
              </v-row>
              <v-row class="mx-0" :class="getTextFieldPadding">
                <v-col class="pb-0 pt-1" cols="11" sm="6">
                  <v-textarea
                      outlined
                      v-model="currentEditIssue.name"
                      role="textbox"
                      placeholder="..."
                      dense
                      class="dense-textarea"
                      :min-height="30"
                      :rules="[alertRules.required]"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row class="mx-0">
                <p class="pb-0 pl-5 alert-editor-label">Description</p>
              </v-row>
              <v-row class="mx-0 mt-2" :class="getTextFieldPadding">
                <v-col class="pb-0 pt-1" cols="11" sm="6">
                  <v-textarea
                      outlined
                      v-model="currentEditIssue.description"
                      role="textbox"
                      placeholder="..."
                      dense
                      class="dense-textarea"
                      :min-height="30"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row class="mx-0">
                <p class="pb-0 pl-5 alert-editor-label">Sources</p>
              </v-row>
              <v-row class="mx-0" :class="getTextFieldPadding">
                <v-col class="pb-0 pt-1 mt-2" cols="11" sm="6">
                  <v-select
                      multiple
                      v-model="currentEditIssue.sourceIds"
                      :menu-props="{ offsetY: true, maxHeight: '250' }"
                      outlined
                      dense
                      color="primary"
                      :items="availableServers"
                      item-text="name"
                      item-value="id"
                      label="Choose Servers"
                      persistent-hint
                      :rules="[alertRules.requiredServer]"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                          style="
                          max-height: 40px;
                          border-bottom: 1px solid #7f7f7f;
                        "
                          ripple
                          @click="selectAllServers('currentEditIssue')"
                      >
                        <v-list-item-content>
                          <v-list-item-title
                              :class="
                              currentEditIssue.sourceIds.length ===
                              availableServers.length
                                ? 'primary--text'
                                : $vuetify.theme.dark
                                ? 'white--text'
                                : 'black--text'
                            "
                              style="font-size: 16px !important; font-weight: 400"
                          >
                            {{
                              (currentEditIssue?.sourceIds?.length === availableServers?.length) ? 'Deselect All' : 'Select All'
                            }}
                          </v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:item="{ item }">
                      {{ item.name }}
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <span
                          v-if="index === 0"
                          :class="{
                          'v-select-char-lim':
                            currentEditIssue.sourceIds.length > 1,
                        }"
                          class="mr-1"
                      >{{ item.name }}</span
                      >
                      <span v-if="index === 1">
                        (+{{ currentEditIssue.sourceIds.length - 1 }}
                        others)
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <div v-for="setting in getAlertSettingsNames" :key="setting">
                <v-row v-if="!!currentEditIssue.alertType && !!setting" justify="space-between" class="mx-0">
                  <p class="pb-0 pl-5 alert-editor-label">
                    {{
                      currentEditIssue.alertType.arguments[
                          setting
                          ].friendlyName.split("_").length > 1
                          ? currentEditIssue.alertType.arguments[
                              setting
                              ].friendlyName.split("_")[0] +
                          " " +
                          currentEditIssue.alertType.arguments[
                              setting
                              ].friendlyName.split("_")[1]
                          : currentEditIssue.alertType.arguments[
                              setting
                              ].friendlyName.split("_")[0]
                    }}
                    {{
                      currentEditIssue.alertType.arguments[setting].metricUnit
                          ? "(" +
                          currentEditIssue.alertType.arguments[setting]
                              .metricUnit +
                          ")"
                          : ""
                    }}
                  </p>
                  <v-checkbox
                      v-if="
                      (currentEditIssue.alertType.arguments[setting].type ===
                        'double' ||
                        currentEditIssue.alertType.arguments[setting].type ===
                          'number') &&
                      !currentEditIssue.alertType.arguments[setting]
                        .plainValueOnly
                    "
                      class="pb-2 pr-5 small-checkbox"
                      v-model="currentEditIssue.arguments[setting].customValue"
                      @change="updateVue"
                      small
                      dense
                      label="Other value"
                      style="font-size: 8px !important"
                  ></v-checkbox>
                </v-row>
                <template
                    v-if="
                    currentEditIssue.arguments[setting].customValue ||
                    currentEditIssue.alertType.arguments[setting].plainValueOnly
                  "
                >
                  <v-row
                      style="margin-top: -12px"
                      class="mx-0"
                      :class="getTextFieldPadding"
                  >
                    <v-col class="py-0 mt-4" cols="11" sm="6">
                      <v-text-field
                          outlined
                          dense
                          v-model.number="currentEditIssue.arguments[setting].value"
                          type="number"
                          :rules="constructRules(currentEditIssue.arguments[setting].value, currentEditIssue.alertType.arguments[setting].min, currentEditIssue.alertType.arguments[setting].max, true)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <template v-else-if="
                currentEditIssue.alertType.arguments[setting].type ===
                'double' ||
                currentEditIssue.alertType.arguments[setting].type ===
                'number'">
                  <v-row v-if="
                (Number(currentEditIssue.alertType.arguments[setting].step) > 0) &&
                (Number(currentEditIssue.alertType.arguments[setting].max) > 0)"
                  >
                    <v-slider
                        :min="Number(currentEditIssue.alertType.arguments[setting].min) || 0"
                        :max="Number(currentEditIssue.alertType.arguments[setting].max)"
                        ticks="always"
                        :step="Number(currentEditIssue.alertType.arguments[setting].step)"
                        thumb-label="always"
                        :class="[
                    currentEditIssue.alertType.arguments[setting].max /
                      currentEditIssue.alertType.arguments[setting].step >
                    100
                      ? 'slider-ticks-many'
                      : 'slider-ticks-few',
                    getSlidersPadding,
                  ]"
                        style="text-align: center; margin: auto"
                        v-model="currentEditIssue.arguments[setting].value"
                        :rules="constructRules(currentEditIssue.arguments[setting].value, currentEditIssue.alertType.arguments[setting].min, currentEditIssue.alertType.arguments[setting].max, false)"
                    >
                      <template v-slot:thumb-label="{ value }">
                        <div class="pt-1 ec-slider" :style="sliderStyle(value)">
                          {{ value }}
                        </div>
                      </template>
                    </v-slider>
                  </v-row>
                  <v-row v-else>
                    <v-row
                        style="margin-top: -12px"
                        class="mx-0"
                        :class="getTextFieldPadding"
                    >
                      <v-col class="py-0" cols="11" sm="6">
                        <v-text-field
                            outlined
                            dense
                            v-model.number="currentEditIssue.arguments[setting].value"
                            type="number"
                            :rules="constructRules(currentEditIssue.arguments[setting].value, currentEditIssue.alertType.arguments[setting].min, currentEditIssue.alertType.arguments[setting].max, true)"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-row>
                </template>
                <template v-else-if="
                    currentEditIssue.alertType.arguments[setting].type ===
                    'boolean'
                  ">
                  <v-row
                      class="mx-0"
                      :class="getTextFieldPadding"
                  >
                    <v-checkbox
                        class="pb-2 pr-5 small-checkbox"
                        v-model="currentEditIssue.arguments[setting].value"
                        small
                        dense
                        label="Yes / No"
                        style="font-size: 8px !important"
                    ></v-checkbox>
                  </v-row>
                </template>
                <template v-else>
                  <v-row class="pl-15 mx-0">
                    <v-col cols="11" sm="6">
                      <v-textarea
                          outlined
                          v-model="currentEditIssue.arguments[setting].value"
                          role="textbox"
                          placeholder="..."
                          dense
                          class="dense-textarea"
                          :min-height="30"
                          :rules="
                        currentEditIssue.alertType.arguments[setting].type ===
                        'array (number)'
                          ? [alertRules.containNumber]
                          : [alertRules.required]
                      "
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                </template>
              </div>
              <p class="pl-5 alert-editor-label">Notification</p>
              <!-- NOTIFICATION TYPE -->
              <v-row
                  class="mx-0 mt-2"
                  :class="$vuetify.breakpoint.smAndUp ? 'pl-15' : 'pl-10'"
              >
                <specifications
                    v-model="currentEditIssue.specifications.dynamicThreshold"
                    :type="currentEditIssue.notificationType"
                    :options="alertImportance"
                    @change-type="changeNotificationTypeHandler"
                    @change-settings="changeNotificationSettingsHandler"
                />
              </v-row>
              <p class="text-center mx-0 alert-editor-label" style="font-size: 16px">
                Select Days ({{
                  Object.keys(currentEditIssue.daysOfWeek).filter(
                      (el) => currentEditIssue.daysOfWeek[el].value
                  ).length
                }})
              </p>
              <v-row class="days-of-week mx-0">
                <v-col cols="12">
                  <v-row justify="center">
                    <div
                        class="days-wrap"
                        v-for="day in Object.keys(currentEditIssue.daysOfWeek)"
                        :key="day"
                    >
                      <v-btn
                          text
                          :key="daysSelectorRenderKey"
                          v-model="currentEditIssue.daysOfWeek[day].value"
                          @click="selectDayOfWeekEditing(day)"
                          class="one-color day"
                          :class="
                          currentEditIssue.daysOfWeek[day].value
                            ? 'selected-day'
                            : 'supplementary-class'
                        "
                          color="primary"
                          hide-details
                      >
                        <template v-slot:default>
                          <p class="mb-0">
                            <span
                                :class="{ 'black--text': !$vuetify.theme.dark }"
                                style="display: block"
                            >{{ day }}</span
                            >
                            <span
                                v-if="currentEditIssue.daysOfWeek[day]"
                                :key="dayTimeRenderKey"
                                style="color: gray !important; font-size: 11px"
                            >{{ getDayTime(day, "currentEditIssue") }}</span
                            >
                          </p>
                        </template>
                      </v-btn>
                      <div
                          style="
                          width: 68px;
                          height: 20px;
                          padding-bottom: 25px;
                          margin-top: -5px;
                        "
                          class="text-center day-edit-wrapper"
                          :class="
                          currentEditIssue.daysOfWeek[day].value
                            ? 'selected-day'
                            : 'supplementary-class'
                        "
                      >
                        <v-btn
                            @click="editAlertTime(day)"
                            dense
                            x-small
                            width="22"
                            height="22"
                            icon
                            :class="{
                            'selected-day':
                              currentEditIssue.daysOfWeek[day].value,
                          }"
                        >
                          <v-icon style="font-size: 14px; margin-left: 1px"
                          >far fa-clock
                          </v-icon
                          >
                        </v-btn>
                      </div>
                    </div>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="center" class="pt-5 mx-0">
                <p style="margin-bottom: -10px">
                  {{ daysOfWeek[currentDayEditing] }}
                </p>
              </v-row>
              <v-row
                  v-if="newAlert.daysOfWeek[this.currentDayEditing]"
                  justify="center"
                  class="mx-0"
              >
                <v-col
                    cols="11"
                    sm="6"
                    :class="{ 'py-0': $vuetify.breakpoint.xsOnly }"
                    style="height: 50px"
                >
                  <v-row
                      id="timing-wrapper"
                      :justify="$vuetify.breakpoint.xsOnly ? 'center' : 'end'"
                      align="center"
                      :class="{ 'pr-4': $vuetify.breakpoint.smAndUp }"
                  >
                    <div>
                      <p class="mb-0 mt-3 mr-5">From</p>
                    </div>
                    <v-text-field
                        style="max-width: 35px"
                        dense
                        v-model.number="fromHour"
                        @input="(value) => timeChanged(value, 'from', 'hours')"
                        class="pt-0 my-0 no-underline align-center"
                        type="number"
                        :min="minHour"
                        :max="maxHour"
                        step="1"
                        required
                        hide-details
                    ></v-text-field
                    >
                    :
                    <v-text-field
                        style="max-width: 35px"
                        dense
                        v-model="fromMinute"
                        @input="(value) => timeChanged(value, 'from', 'minutes')"
                        class="pt-0 my-0 no-underline align-center"
                        type="number"
                        :min="minMinute"
                        :max="maxMinute"
                        step="1"
                        required
                        hide-details
                    ></v-text-field>
                    <v-select
                        class="dayPeriods"
                        style="max-width: 35px !important; margin-left: 4px"
                        v-model="
                        currentEditIssue.daysOfWeek[currentDayEditing].time.from
                          .dayPeriod
                      "
                        @change="rerenderDayTime"
                        :items="dayPeriods"
                    ></v-select>
                  </v-row>
                </v-col>
                <v-col
                    cols="11"
                    sm="6"
                    :class="{ 'py-0': $vuetify.breakpoint.xsOnly }"
                    class="pb-0"
                    style="height: 50px"
                >
                  <v-row
                      align="center"
                      :justify="$vuetify.breakpoint.xsOnly ? 'center' : 'start'"
                      :class="{ 'pr-4': $vuetify.breakpoint.smAndUp }"
                      class="mx-0"
                  >
                    <div>
                      <p class="mb-0 mt-3 mr-5">To</p>
                    </div>
                    <v-text-field
                        style="max-width: 35px"
                        dense
                        v-model="toHour"
                        @input="(value) => timeChanged(value, 'to', 'hours')"
                        class="pt-0 my-0 no-underline align-center"
                        type="number"
                        :min="minHour"
                        :max="maxHour"
                        step="1"
                        required
                        hide-details
                    ></v-text-field
                    >
                    :
                    <v-text-field
                        style="max-width: 35px"
                        dense
                        v-model="toMinute"
                        @input="(value) => timeChanged(value, 'to', 'minutes')"
                        class="pt-0 my-0 no-underline align-center"
                        type="number"
                        :min="minMinute"
                        :max="maxMinute"
                        step="1"
                        required
                        hide-details
                    ></v-text-field>
                    <v-select
                        class="dayPeriods"
                        style="max-width: 35px !important; margin-left: 4px"
                        v-model="
                        currentEditIssue.daysOfWeek[currentDayEditing].time.to
                          .dayPeriod
                      "
                        :items="dayPeriods"
                        @change="rerenderDayTime"
                    ></v-select>
                  </v-row>
                </v-col>
              </v-row>
              <!-- SUBSCRIPTION GROUPS-->
              <v-row class="mx-0">
                <p class="pb-0 pl-5 alert-editor-label">Subscription Groups</p>
              </v-row>
              <v-row class="mx-0">
                <subscription-groups :alert-card="{id: currentEditIssue.id, name: currentEditIssue.name}"/>
              </v-row>
            </v-form>
          </div>
        </div>
        <v-row class="mx-0 accent" justify="space-between">
          <v-btn class="ma-2 opacity-1-slow" text @click="closeAlertEditor"
          >Cancel
          </v-btn
          >
          <v-btn
              v-if="!edit"
              :disabled="wizard === 1"
              class="my-2 opacity-1-slow"
              text
              @click="wizardBack"
          >Back
          </v-btn
          >
          <v-spacer></v-spacer>
          <div
              v-if="wizard < 3 && !edit"
              @click="disableContinueWizard ? validateForm() : wizardContinue()"
          >
            <v-btn
                :disabled="disableContinueWizard"
                class="ma-2 opacity-1-slow"
                color="primary"
            >continue
            </v-btn
            >
          </div>
          <div v-else @mouseenter="checkSaveThresholdEligibility">
            <v-btn
                :disabled="(!editValidForm && edit) || (disableContinueWizard && !edit)"
                color="primary"
                class="ma-2"
                :class="wizard < 3 && !edit ? 'opacity-0' : 'opacity-1-slow'"
                @click="edit ? saveAlertCardEdit() : saveAlertCard()"
            >save
            </v-btn
            >
          </div>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- <v-dialog
      v-model="cardInfoOptionDialog"
      overlay-color="grey darken-2"
      transition="scroll-x-transition"
      width="400"
      persistent
    >
      <v-card
        class="accent"
        style="max-width:400px;overflow-y: hidden !important;"
      >
        <v-card-title style="background-color:#47BD96;color:white"
          >New Tabs Row</v-card-title
        >
        <v-form v-model="cardInfoForm" class="ma-4">
          <v-tooltip content-class="tooltipClass" bottom>
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="tabsPropertyName"
                dense
                outlined
                label="Property name"
                :rules="[rules.required]"
                style="max-width: 250px;"
              >
              </v-text-field>
            </template>
            <span>
              The name of the array variable<br />that will be used to create
              tabs
            </span>
          </v-tooltip>
          <div class="ml-1">Add as:</div>
          <v-radio-group
            v-model="cardInfoOptionRadio"
            row
            class="mt-2"
            hide-details
          >
            <v-radio
              label="Next Item"
              value="next"
              class="small-checkbox"
            ></v-radio>
            <v-radio
              label="Previous Item"
              value="prev"
              class="small-checkbox"
            ></v-radio>
          </v-radio-group>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
import {
  defaultAlertCard,
  defaultAlertTWType,
  defaultDynamicThreshold,
  TWDaysAndTiming,
} from "@/utilities/DefaultObjects";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {ALERT_SORTS, ALERT_STATUSES, APP_STATE_SECTIONS, CARD_INFO_ROW_TYPES,} from "@/utilities/enums";
import {ConfirmDialog, DefaultPage, LoadingPage,} from "../components/Default-Page-Components";
import {ApplicationDefinitionService, SettingsService, TradeWatcherService,} from "@/services/ApiService";
import AlertCard from "../components/AlertCard";
import AlertsDrawer from "../components/AlertsDrawer";
import formatSql from "../utilities/sql-formatter";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import {syncScroll} from "@/utilities/tradewatcher-helpers";

import {cloneDeep} from "lodash";
import Specifications from "@/components/TradeWatcher/Specifications.vue";
import SubscriptionGroups from "@/components/TradeWatcher/SubscriptionGroups.vue";
import ToggleDenseGrid from "@/components/TradeWatcher/ToggleDenseGrid.vue";
import DataTransfer from "@/components/TradeWatcher/DataTransfer.vue";

let timeUpdateInterval;

export default {
  name: "TradeWatcher",
  components: {
    DataTransfer,
    ToggleDenseGrid,
    SubscriptionGroups,
    Specifications,
    ConfirmDialog,
    AlertCard,
    AlertsDrawer,
    DefaultPage,
    LoadingPage,
  },
  data: () => ({
    queryValidationRenderKey: 0,
    alertToDelete: null,
    deletingHistory: false,
    lazyLoadAlertCards: true,
    dayTimeRenderKey: 0,
    // alertsDrawerRenderKey: 0,
    paginationRenderKey: 0,
    daysSelectorRenderKey: 0,
    unsavedMsgRenderKey: 0,
    cardInfoOptionRadio: null,
    cardInfoForm: false,
    rules: {
      required: (val) => {
        if (!!val || val === 0) {
          return true;
        } else return "Required";
      },
    },
    tabsPropertyName: null,
    cardInfoOptionDialog: false,
    CARD_INFO_ROW_TYPES: CARD_INFO_ROW_TYPES,
    cardInfoArray: [{type: CARD_INFO_ROW_TYPES.KEY_VALUE, id: 0}],
    syncScroll: syncScroll,
    lazyIsActive: false,
    alertsCountChanged: false,
    itemsPerPage: 25,
    page: 1,
    totalHistoryPages: 0,
    totalAlertCardsPages: 0,
    showNoArgsError: false,
    ALERT_STATUSES: ALERT_STATUSES,
    availableServers: [],
    totalAlerts: 0,
    initialLoad: true,
    loadingAlertTypes: false,
    loadingAlertStatistics: false,
    loadingAlertHistory: false,
    alertHistory: [],
    tempBool: true,
    ALERT_CARD_ACTIONS: {
      ENABLE: 0,
      DISABLE: 1,
    },
    alertCardDelitingId: null,
    alertCardDelitingName: null,
    denseGrid: false,
    showFormatSettings: false,
    querySpaces: 3,
    formattedQuery: null,
    queryDialog: false,
    alertTypeTabs: null,
    infoTabs: null,
    historyFilter: "all",
    historySorting: ALERT_SORTS.DESC,
    ALERT_SORTS: ALERT_SORTS,
    showingAllHistory: true,
    alertContainerClass: "simple-slow-opacityAN",
    twTabs: 0,
    showHistory: false,
    selectedCard: null,
    alertDrawerClipped: false,
    editingAlertType: false,
    addingNewAlertType: false,
    selectedATArgument: {},
    alertTypeEditing: null,
    twAdminDialog: false,
    confirmDialog: false,
    tabs: null,
    alertRules: {
      requiredObject: (value) => {
        return Object.keys(value).length ? true : "Required";
      },
      required: (value) => !!value || "Required",
      requiredServer: (value) =>
          value.length > 0 || "Select at least one server",
      notZeroOrNegative: (value) => !(value <= 0) || "Must be greater than 0",
      notNegative: (value) => !(value < 0) || "Must not be negative",
      containNumber: (v) => /\d/.test(v) || "Must contain number",
      greaterOrEqualThan: (v, min) => v >= min || `Must be greater than or equal to ${min}`,
      lessOrEqualThan: (v, max) => v <= max || `Must be less than or equal to ${max}`,
    },
    wizardBacked: false,
    validForm1: true,
    validForm2: true,
    validForm3: true,
    adminForm: false,
    editValidForm: true,
    currentDayEditing: "",
    minHour: 0,
    maxHour: 11,
    minMinute: 0,
    maxMinute: 59,
    dayPeriods: ["am", "pm"],
    daysOfWeek: {
      mon: "Monday",
      tue: "Tuesday",
      wed: "Wednesday",
      thu: "Thursday",
      fri: "Friday",
      sat: "Saturday",
      sun: "Sunday",
    },
    newAlert: JSON.parse(JSON.stringify(defaultAlertCard)),
    alertTypes: [],
    selectedAlertType: {},
    alertImportance: [
      {
        name: "Continuous",
        id: "CONTINUOUS",
        icon: "fas fa-exclamation-triangle",
        iconColor: "red",
        description: "Continuous as far as the event is active",
        dynamicThreshold: {
          enable: {
            key: 'enable',
            label: 'Enable',
          },
          nextLevel: {
            key: 'nextLevel',
            label: 'Next Level',
          },
          argumentName: {
            key: 'argumentName',
            label: 'Argument Name',
          },
          changeLevelType: {
            key: 'changeLevelType',
            label: 'Level Type',
            options: [
              {value: 'AMOUNT', label: 'Amount'},
              {value: 'PERCENTAGE', label: 'Percentage'},
              {value: 'ABSOLUTE_AMOUNT', label: 'Absolute Amount'},
              {value: 'ABSOLUTE_PERCENTAGE', label: 'Absolute Percentage'},
            ]
          },
        },
      },
      {
        id: "FIRE_AND_FORGET",
        name: "Fire and forget",
        iconColor: "primary",
        description:
            "Fire and forget alert will be showed once to the end-user and remain visible as long the alert is active",
      },
      {
        id: "AWAIT_ACKNOWLEDGE",
        name: "Await Acknowledge",
        icon: "fas fa-user-clock",
        iconColor: "orange",
        description:
            "Await Acknowledge is a continuous alert which stops on user interaction. Intended to be acknowledged by the operator",
      },
    ],
    edit: false,
    currentEditIssue: {
      daysOfWeek: JSON.parse(JSON.stringify(TWDaysAndTiming)),
      importance: 2,
    },
    currentTable: null,
    wizard: 1,
    dialog: false,
    alertCards: [],
    // alertDrawerCards is needed so that the main alert cards don't get rerendered every time you hover and item on the drawer
    alertDrawerCards: [],
    issuesDrawer: false,
    hovered: false,
    filters: {
      all: {label: 'All', value: 'all', checked: true},
      unconfirmed: {label: 'Unconfirmed', value: 'unconfirmed', checked: false},
      confirmed: {label: 'Confirmed', value: 'confirmed', checked: false},
    },
    hasChanges: false,
    alertTypeActionLoading: false,
    showNotificationInfo: false,
  }),
  computed: {
    isDenseGrid: {
      get() {
        // console.log('this.getSettings.applicationState.tradewatcher.denseGrid', this.getSettings.applicationState.tradewatcher.denseGrid);
        return this.getSettings.applicationState.tradewatcher.denseGrid;
      },
      set(newValue) {
        this.toggleDenseGrid(newValue);
      }
    },
    confirmationDialogText() {
      if (this.deletingHistory) {
        return `Delete all alerts of "${this.alertToDelete.alertStatistics.name}" card?`;
      } else return `Delete ${this.alertCardDelitingName}?`;
    },
    getCardsLGLayout() {
      if (
          this.alertDrawerClipped &&
          this.getMiniDrawer &&
          this.$vuetify.breakpoint.width < 1500
      ) {
        return 6;
      }
      if (
          ((this.alertDrawerClipped || this.getMiniDrawer) &&
              this.$vuetify.breakpoint.width < 1450) ||
          (this.alertDrawerClipped &&
              this.getMiniDrawer &&
              this.$vuetify.breakpoint.width < 1650)
      ) {
        return 4;
      } else return 3;
    },
    alertContainerClasses() {
      return this.alertDrawerClipped && this.$vuetify.breakpoint.mdAndUp
          ? this.alertContainerClass + " pr-279px"
          : this.alertContainerClass;
    },
    totalPages() {
      return this.showHistory
          ? this.totalHistoryPages
          : this.totalAlertCardsPages;
    },
    getEmptyHistoryStateText() {
      switch (this.historyFilter) {
        case "unconfirmed":
          return "All alerts are confirmed";
        case "confirmed":
          return "No confirmed alerts";
        default:
          return "No history cards";
      }
    },
    getStepHint() {
      if (
          !isNaN(this.selectedATArgument.max) && // Make sure that max & step are numbers
          !isNaN(this.selectedATArgument.step) &&
          this.selectedATArgument.max / this.selectedATArgument.step > 200
      )
        return 'Low performance! Set "Force other value" to true!';
      else return "";
    },
    getAlertPropName() {
      return this.edit ? "currentEditIssue" : "newAlert";
    },
    emptyPageStateText() {
      if (this.isUserNoAlertCards && !this.alertTypes.length)
        return "It seems that you don't have any alert types yet. Please refer to the admin.";
      else if (this.isUserNoAlertCards)
        return "It seems that you don't have any alert cards yet. Click Get Started below to create an alert card";
      else
        return "It seems that you don't have any alert types yet. Click Get Started below to create an alert type";
    },
    isAdminNoAlertTypes() {
      return this.isAdmin && !this.alertTypes.length;
    },
    isUserNoAlertCards() {
      return !this.isAdmin && !this.alertCards.length;
    },
    cards() {
      return this.showHistory ? this.alertHistory : this.alertCards;
    },
    isDoubleOrNumber() {
      switch (this.selectedATArgument.type) {
        case "double":
        case "number":
          return true;
        default:
          return false;
      }
    },
    alertDrawerMobile() {
      return this.$vuetify.breakpoint.smAndDown || this.isNotDesktop;
    },
    getTextFieldPadding() {
      return this.$vuetify.breakpoint.smAndUp ? "pl-15" : "pl-10";
    },
    getSlidersPadding() {
      return this.$vuetify.breakpoint.smAndUp ? "px-15" : "px-10";
    },
    getAlertSettingsNames() {
      return Object.keys(this.currentEditIssue.arguments);
    },
    disableContinueWizard() {
      switch (this.wizard) {
        case 1:
          return !this.validForm1;
        case 2:
          return !this.validForm2;
        case 3:
          let canSaveAlert = true;
          if ((this.newAlert.notificationType === "CONTINUOUS") && !this.edit) {
            if (
                !((!!this.newAlert.specifications?.dynamicThreshold?.changeLevelType) &&
                    (this.newAlert.specifications?.dynamicThreshold?.changeLevelType.length > 0))
            ) {
              canSaveAlert = false;
            }
          }
          return (!this.validForm3 && !canSaveAlert);
        default:
          return false;
      }
    },
    fromMinute: {
      get() {
        return this.forceTwoDigits(
            this[this.getAlertPropName].daysOfWeek[this.currentDayEditing].time
                .from.minutes
        );
      },
      set(v) {
        this[this.getAlertPropName].daysOfWeek[
            this.currentDayEditing
            ].time.from.minutes = Number(v);
      },
    },
    fromHour: {
      get() {
        return this.forceTwoDigits(
            this[this.getAlertPropName].daysOfWeek[this.currentDayEditing].time
                .from.hours
        );
      },
      set(v) {
        this[this.getAlertPropName].daysOfWeek[
            this.currentDayEditing
            ].time.from.hours = Number(v);
      },
    },
    toMinute: {
      get() {
        return this.forceTwoDigits(
            this[this.getAlertPropName].daysOfWeek[this.currentDayEditing].time.to
                .minutes
        );
      },
      set(v) {
        this[this.getAlertPropName].daysOfWeek[
            this.currentDayEditing
            ].time.to.minutes = Number(v);
      },
    },
    toHour: {
      get() {
        return this.forceTwoDigits(
            this[this.getAlertPropName].daysOfWeek[this.currentDayEditing].time.to
                .hours
        );
      },
      set(v) {
        this[this.getAlertPropName].daysOfWeek[
            this.currentDayEditing
            ].time.to.hours = Number(v);
      },
    },
    ...mapGetters(["isAdmin"]),
    ...mapGetters(["getMiniDrawer"]),
    ...mapGetters(["getSpecificSetting"]),
    ...mapGetters(["getSettings"]),
  },
  methods: {
    ...mapMutations(["updateApplicationState"]),
    ...mapActions(["updateAppSettingsRemotely"]),
    /**
     * Construct the rules for the alert arguments numeric input fields
     *
     * @param value {number} - The value to be validated
     * @param min {number} - The minimum value
     * @param max {number} - The maximum value
     * @param required {boolean} - If the field is required
     */
    constructRules(value, min, max, required) {
      let rulesArray = [];
      if (min) {
        rulesArray.push(this.alertRules.greaterOrEqualThan(value, min));
      }
      if (max) {
        rulesArray.push(this.alertRules.lessOrEqualThan(value, max));
      }
      if (required) {
        rulesArray.push(this.alertRules.required);
      }
      return rulesArray;
    },
    refresh() {
      this.fetchDefinitions();
      let alertDrawerClipped = JSON.parse(
          localStorage.getItem("alertDrawerClipped")
      );

      if (alertDrawerClipped != null) {
        this.alertDrawerClipped = alertDrawerClipped;
      }
      TimeAgo.addLocale(en);
      this.timeAgo = new TimeAgo("en-US");
      this.loadingAlertStatistics = true;
      this.fetchAlertStatistics();
      this.loadingAlertTypes = true;
      this.getAlertTypes();
    },
    /**
     * Handle the notification type selection
     * @param selectedType {String} - The selected notification type id (string value)
     */
    changeNotificationTypeHandler(selectedType) {
      if (this.edit === true) {
        this.currentEditIssue.notificationType = selectedType;
      } else {
        this.newAlert.notificationType = selectedType;
      }
    },
    /**
     * Handle the notification settings changes for
     * Dynamic Threshold
     * @param settingsData {Object} - The settings data to attach
     * ({enable: boolean, nextLevel: number, argumentName: string, changeLevelType: string})
     */
    changeNotificationSettingsHandler(settingsData) {
      if (
          (settingsData.hasOwnProperty('enable')) &&
          settingsData.hasOwnProperty('nextLevel') &&
          settingsData.hasOwnProperty('argumentName') &&
          (settingsData.hasOwnProperty('changeLevelType'))
      ) {
        if (this.edit === true) {
          this.currentEditIssue['specifications'].dynamicThreshold.enable = settingsData.enable;
          this.currentEditIssue['specifications'].dynamicThreshold.nextLevel = settingsData.nextLevel;
          this.currentEditIssue['specifications'].dynamicThreshold.argumentName = settingsData.argumentName;
          this.currentEditIssue['specifications'].dynamicThreshold.changeLevelType = settingsData.changeLevelType;
        } else {
          // console.log('NEW ALERTS SPECS change settingsData', settingsData);
          this.newAlert['specifications'].dynamicThreshold.enable = settingsData.enable;
          this.newAlert['specifications'].dynamicThreshold.nextLevel = settingsData.nextLevel;
          this.newAlert['specifications'].dynamicThreshold.argumentName = settingsData.argumentName;
          this.newAlert['specifications'].dynamicThreshold.changeLevelType = settingsData.changeLevelType;
        }
      }
    },
    getFullIdentity(definition) {
      let stringID = definition.id.toString();
      let numberOfDigits = stringID.length;
      switch (numberOfDigits) {
        case 1:
          stringID = "00" + stringID;
          break;
        case 2:
          stringID = "0" + stringID;
          break;
      }

      return definition.application.code + stringID;
    },
    modifyQueryValidation() {
      this.alertTypeEditing.skipQueryValidation =
          !this.alertTypeEditing.skipQueryValidation;
      this.queryValidationRenderKey > 10 ? this.queryValidationRenderKey = 0 : this.queryValidationRenderKey++
    },
    deleteHistoryCard(card) {
      let cardName = card.name;
      TradeWatcherService.Alerts.delete(card.id)
          .then(() => {
            // If alert deleted was UNACKNOWLEDGED then update the notification panel
            if (card.status === "UNACKNOWLEDGED") {
              this.$emit("update-alerts-total");
            }
            // Cover the case where the alert deleted was the last alert on the page - and now the page shifts by -1
            let forceRerenderPagination = false;
            // let params = {page: this.page - 1}
            if (this.cards.length === 1 && this.page > 0) {
              this.page -= 1;
              forceRerenderPagination = true;
            }

            let params = {page: null};
            if (this.page > 0) params.page = this.page - 1;
            else params.page = this.page;

            let finalParams = this.getHistoryFetchParams({
              page: 0,
            });

            this.fetchTWNotifications(
                finalParams,
                null,
                false,
                forceRerenderPagination,
                card
            );

            this.confirmDialog = false;

            this.$notifier.success(`Alert has been deleted`);
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error(`Couldn't delete the history of ${cardName}!`);
          });
    },
    confirmHistoryDelete(alertDrawerCard) {
      this.alertToDelete = alertDrawerCard;
      this.deletingHistory = true;
      this.confirmDialog = true;
    },
    confirmationDialogEvent(ev) {
      if (!ev) {
        this.confirmDialog = false;
        return;
      }
      this.deletingHistory ? this.deleteHistory() : this.deleteAlertCard();
    },
    deleteHistory() {
      // TODO
      // if (this.showingAllHistory) {
      //   this.deleteAllHistory();
      //   return;
      // }
      if (
          !this.alertToDelete ||
          !this.alertToDelete.alertStatistics ||
          !this.alertToDelete.alertStatistics.alertCardId
      )
        return;
      let statistics = this.alertToDelete.alertStatistics;
      TradeWatcherService.Alerts.deleteByCardId(statistics.alertCardId)
          .then(() => {
            this.$emit("update-alerts-total", {ifAnyExist: true});
            this.fetchAlertStatistics(false, true, statistics.alertCardId);
            if (
                this.showHistory &&
                this.selectedCard.id === statistics.alertCardId
            ) {
              let params = this.getHistoryFetchParams({
                page: 0,
              });
              this.fetchTWNotifications(params, null, true, true);
            }
            this.confirmDialog = false;
            this.$notifier.success(`History of '${statistics.name}' deleted!`);
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error(
                `Couldn't delete the history of ${statistics.name}!`
            );
          });
    },
    // TODO
    // deleteAllHistory() {
    //   TradeWatcherService.Alerts.delete()
    //     .then((response) => {
    //       this.fetchTWNotifications({ page: 0 });
    //       this.confirmDialog = false;
    //       this.$notifier.success("History of alert cards deleted!");
    //     })
    //     .catch(() => {
    //       this.$notifier.error("Couldn't delete history!");
    //     });
    // },
    toggleSorting() {
      this.historySorting =
          this.historySorting === ALERT_SORTS.DESC
              ? ALERT_SORTS.ASC
              : ALERT_SORTS.DESC;
      this.paginationChangeHandler(1, true); // Fetch sorted items & rerender pagination
    },
    /**
     * Select or deselect all available source IDs of the specified object
     * @param objName {string} - the name of the object to handle selection of source IDs of
     */
    selectAllServers(objName) {
      // console.log('this[objName]', this[objName]);
      if (this[objName].sourceIds.length === this.availableServers.length) {
        let length = this[objName].sourceIds.length;
        for (let i = 0; i < length; i++) {
          this[objName].sourceIds.pop();
        }
      } else {
        // console.log('this.availableServers', this.availableServers);
        this.availableServers.forEach((el) => {
          if (this[objName].sourceIds.every((source) => source !== el.id)) {
            this[objName].sourceIds.push(el.id);
          }
        });
      }
    },
    clipAlertsDrawer() {
      this.alertDrawerClipped = !this.alertDrawerClipped;
      localStorage.setItem("alertDrawerClipped", this.alertDrawerClipped);
    },
    sliderStyle(val) {
      let digits = val.toString().length;
      if (digits > 1) {
        return `width: ${
            digits * 7 + 10
        }px !important;background: #47bd96 !important;`;
      } else {
        return `opacity: 1;`;
      }
    },
    openCardInfoOptionDialog() {
      this.cardInfoOptionDialog = true;
    },
    deleteInfoItem(id) {
      if (this.cardInfoArray.length === 1) {
        return;
      }
      let index = this.cardInfoArray.findIndex((el) => el.id === id);
      if (index !== -1) this.cardInfoArray.splice(index, 1);
    },
    addInfoItem() {
      this.cardInfoArray.push({text: "Row", id: this.cardInfoArray.length});
    },
    scrollIntoView(parent, child) {
      const parentBounding = parent.getBoundingClientRect(),
          clientBounding = child.getBoundingClientRect();

      const parentBottom = parentBounding.bottom,
          parentTop = parentBounding.top,
          clientBottom = clientBounding.bottom,
          clientTop = clientBounding.top;

      if (parentTop >= clientTop) {
        this.scrollTo(parent, -(parentTop - clientTop), 300);
      } else if (clientBottom > parentBottom) {
        this.scrollTo(parent, clientBottom - parentBottom, 300);
      }
    },
    scrollTo(element, to, duration) {
      let start = element.scrollTop,
          currentTime = 0,
          increment = 20;

      let easeInOutQuad = this.easeInOutQuad;

      let animateScroll = function () {
        currentTime += increment;

        let val = easeInOutQuad(currentTime, start, to, duration);
        element.scrollTop = val;

        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };

      animateScroll();
    },
    easeInOutQuad(time, startPos, endPos, duration) {
      time /= duration / 2;

      if (time < 1) return (endPos / 2) * time * time + startPos;
      time--;
      return (-endPos / 2) * (time * (time - 2) - 1) + startPos;
    },
    parseAlertsData(data) {
      return data.map((el) => {
        let date = new Date(el.createdOn);
        el.cardDate = `${date.getDate()}/${
            date.getMonth() + 1
        }/${date.getFullYear()}`;

        el.createdOnHR = this.getHRDate(el.createdOn);

        if (this.selectedCard != null) {
          el.name = this.selectedCard.name;
        } else {
          let alertCard = this.alertCards.find(
              (alertCard) =>
                  alertCard.alertStatistics.alertCardId === el.alertCardId
          );
          if (alertCard) {
            el.name = alertCard.alertStatistics.name;
          } else {
            el.name = "";
          }
        }

        return el;
      });
    },
    // rerenderAlertsDrawerComponent() {
    //   if (this.alertsDrawerRenderKey > 10) this.alertsDrawerRenderKey = 0;
    //   else this.alertsDrawerRenderKey++;
    // },
    rerenderPaginationComponent() {
      if (this.paginationRenderKey > 10) this.paginationRenderKey = 0;
      else this.paginationRenderKey++;
    },
    rerenderDayTime() {
      if (this.dayTimeRenderKey > 10) this.dayTimeRenderKey = 0;
      else this.dayTimeRenderKey++;
    },
    rerenderComponent(keyName) {
      if (this[keyName] > 10) this[keyName] = 0;
      else this[keyName]++;
    },
    paginationChangeHandler(page, rerenderPagination = false) {
      this.page = page;
      let params = this.getHistoryFetchParams({
        size: this.itemsPerPage,
        page: page - 1,
      });
      this.fetchTWNotifications(params, null, true, rerenderPagination);
    },
    updateCardsTime() {
      if (this.showHistory) {
        this.alertHistory = this.alertHistory.map((el) => {
          el.createdOnHR = this.getHRDate(el.createdOn);
          return el;
        });
      } else {
        this.alertCards = this.alertCards.map((el) => {
          el.alertStatistics.lastTriggeredHR = this.getHRDate(
              el.alertStatistics.lastTriggered
          );
          return el;
        });
      }
    },
    getHistoryFetchParams(extraParams = null) {
      let params = {
        sort: `createdOn,${
            this.historySorting === ALERT_SORTS.DESC ? "desc" : "asc"
        }`,
      };

      if (extraParams != null) {
        params = Object.assign(params, extraParams);
      }

      if (this.historyFilter === "unconfirmed")
        params.status = this.ALERT_STATUSES.UNACKNOWLEDGED;
      else if (this.historyFilter === "confirmed")
        params.status = this.ALERT_STATUSES.ACKNOWLEDGED;

      if (this.selectedCard != null) {
        params.alertCardId = this.selectedCard.id;
      }

      return params;
    },
    removeExtraSpacesFromMessage(message) {
      while (message[0] === " " || message[message.length - 1] === " ") {
        if (message[0] === " ") {
          message = message.substring(1, message.length);
        }
        if (message[message.length - 1] === " ") {
          message = message.substring(0, message.length - 1);
        }
      }
      return message;
    },
    acknowledgeAlertOnTWPage(id) {
      this.lazyLoadAlertCards = false;
      if (this.showHistory) {
        if (this.historyFilter === "all") {
          let cardToUpdate = this.alertHistory.find((el) => el.id === id);
          if (cardToUpdate) {
            cardToUpdate.status = ALERT_STATUSES.ACKNOWLEDGED;
          }
        } else if (
            this.historyFilter === "unconfirmed" &&
            this.alertHistory.length === 1
        ) {
          // Get the previous page since this page will be deleted
          if (this.page > 0) this.page = this.page - 1;
          let params = this.getHistoryFetchParams({
            page: this.page > 0 ? this.page - 1 : this.page,
          });
          this.fetchTWNotifications(params, null, false, false, null, true);
        } else {
          this.fetchTWNotifications(null, null, false, false, null, true);
        }
      }
    },
    updateTWAlertsView(scrollTop = true, alertCardId = null) {
      if (this.showHistory) {
        // Update History view
        let params = this.getHistoryFetchParams();
        this.fetchTWNotifications(params, null, scrollTop, false, null);
        // this.fetchTWNotifications(params, null, scrollTop, false, null, title);
      }
      this.fetchAlertStatistics(false, true, alertCardId);
    },
    fetchDefinitions() {
      let params = {
        page: 0,
        size: 9999,
      };
      ApplicationDefinitionService.query({params: params})
          .then((response) => {
            if (response.data.content)
              this.availableServers = response.data.content.reduce(
                  (final, next) => {
                    if (((next.application.code === "AN") || (next.application.code === "PW")) && typeof next == "object")
                      final.push({
                        id: this.getFullIdentity(next),
                        name: next.name,
                      });
                    return final;
                  },
                  []
              );
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error("Couldn't fetch available sources", {
              error: error,
            });
          });
    },
    focusOnDomItem(alertToFocusOn) {
      let i = 0;
      setTimeout(() => {
        var element = document.getElementById(alertToFocusOn);

        // element.classList.add("focusOnAlert");
        if (element != null) {
          let parentEl = document.getElementById("alert-cards-wrapper");
          this.scrollIntoView(parentEl, element);

          element.classList.remove("focusOnAlert");

          if (element.classList.contains("focusOnAlert")) {
            element.classList.remove("focusOnAlert");
          }

          element.classList.add("focusOnAlert");
        }

        i++;
      }, 400);

      setTimeout(() => {
        var element = document.getElementById(alertToFocusOn);
        if (element && element.classList)
          element.classList.remove("focusOnAlert");
      }, 2800);
    },
    acknowledge(id) {
      this.lazyLoadAlertCards = false;
      let params = {
        ids: typeof id == "object" ? id : [id],
        status: "ACKNOWLEDGED",
      };
      TradeWatcherService.Alerts.patch(params)
          .then((response) => {
            if (this.showHistory) {
              // let params = this.getHistoryFetchParams();

              if (this.historyFilter === "unconfirmed") {
                let params;
                if (this.alertHistory.length === 1) {
                  let page = this.page - 1;
                  if (this.totalPages < 2) {
                    page = 1;
                  }
                  this.page = page;
                  params = this.getHistoryFetchParams({page: this.page - 1});
                } else {
                  params = this.getHistoryFetchParams();
                }
                this.alertsCountChanged = true;
                this.fetchTWNotifications(params, null, false, false, null, true);
              } else {
                // TODO
                // This lock will never be executed because if historyFilter == "unconfirmed" then
                // acknowledge method will never be called
                let card = this.alertHistory.find((el) => el.id === id);
                if (card) {
                  card.status = ALERT_STATUSES.ACKNOWLEDGED;
                }
                this.$emit("update-alerts-total", response.data.totalElements);
              }
            }
            this.$notifier.success("Alert acknowledged");
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error("Oops! Couldn't acknowledge the alert", {
              error: error,
            });
          });
    },
    getAlertById(id) {
      return TradeWatcherService.Alerts.get(id);
    },
    focusOnAlert(alertInfo, fetchNotifications = false) {
      this.historyFilter = "unconfirmed";

      let cardIndex = this.alertHistory.findIndex(
          (el) => el.id === alertInfo.id
      );
      // lazyLoadAlertCards = false because to highlight an alert, it needs to be rendered
      this.lazyLoadAlertCards = false;

      if (this.alertHistory[cardIndex] && this.showHistory) {
        this.focusOnDomItem(alertInfo.id);
      } else {
        let page = Math.trunc(alertInfo.index / this.itemsPerPage);

        this.loadingAlertHistory = true;
        let params = this.getHistoryFetchParams({
          page: page,
          size: this.itemsPerPage,
        });
        this.fetchTWNotifications(
            params,
            alertInfo.id,
            false,
            false,
            null,
            true
        );

        if (this.page !== page + 1) {
          this.page = page + 1;
        }
        if (!this.showHistory) this.showHistory = true;
        if (this.twTabs !== 1) this.twTabs = 1;
      }
    },
    preprocessAndOpenEditDialog(issue) {
      // console.log('currentEditIssue issue arg', issue);
      this.currentEditIssue = cloneDeep(issue);

      // if(this.currentEditIssue.hasOwnProperty('specifications')) {
      //   this.currentEditIssue.specifications.dynamicThreshold = {
      //     ...this.currentEditIssue.specifications.dynamicThreshold,
      //
      //   }
      // }
      if (
          this.currentEditIssue.arguments ||
          this.currentEditIssue.arguments.sourceIds
      ) {
        // console.log('has arguments or sourceIds', this.currentEditIssue);
        this.currentEditIssue.sourceIds = JSON.parse(
            JSON.stringify(this.currentEditIssue.arguments.sourceIds)
        );
        // Filter available servers, only the servers that exists are left in this.currentEditIssue.sourceIds
        this.currentEditIssue.sourceIds = this.currentEditIssue.sourceIds.filter(el => {
          return this.availableServers.some(server => server.id === el);
        });
      } else {
        this.currentEditIssue.sourceIds = [];
      }
      // this.currentEditIssue.sourceIds = sourceIds;
      let argsObj = {};
      this.currentEditIssue.alertType.arguments.forEach((el) => {
        // console.log('alertType arguments el', el);
        argsObj[el.name] = Object.assign({}, el);
      });
      // console.log('argsObj', argsObj);

      this.currentEditIssue.alertType.arguments = argsObj; // Parse alert type arguments array to object for the better usability

      Object.keys(argsObj).forEach((argName) => {
        let argSettings = argsObj[argName];

        let isCustomValue = false;

        if (
            this.currentEditIssue.arguments.hasOwnProperty(argName) &&
            this.currentEditIssue.arguments[argName] &&
            (typeof this.currentEditIssue.arguments[argName] === "number")
        ) {
          isCustomValue =
              argSettings.max < this.currentEditIssue.arguments[argName];
        }

        this.currentEditIssue.arguments[argName] = {
          value:
              this.currentEditIssue.arguments.hasOwnProperty(argName) &&
              this.currentEditIssue.arguments[argName]
                  ? this.currentEditIssue.arguments[argName]
                  : argsObj[argName].type === "number" ||
                  argsObj[argName].type === "double"
                      ? 0
                      : argsObj[argName].type === "string"
                          ? ""
                          : argsObj[argName].type === "array (string)" ||
                          argsObj[argName].type === "array (number)"
                              ? []
                              : false,
          customValue: isCustomValue,
          type: argsObj[argName].type,
        };
      });

      if (this.currentEditIssue.arguments) {
        let cardArgs = Object.keys(this.currentEditIssue.arguments);
        let alertTypeArgs = Object.keys(
            this.currentEditIssue.alertType.arguments
        );

        if (cardArgs.length > alertTypeArgs.length) {
          cardArgs.forEach((argName) => {
            if (alertTypeArgs.indexOf(argName) === -1) {
              delete this.currentEditIssue.arguments[argName];
            }
          });
        }
      }

      this.currentEditIssue.daysOfWeek = this.getHumanReadableDaysOfWeek(
          issue.cardSessions
      );

      this.edit = true;
      this.dialog = true;
    },
    getAlertCardById(id) {
      return TradeWatcherService.AlertCards.getById(id);
    },
    getHRDate(lastTriggeredEpoch) {
      let elapsedTime = this.timeAgo.format(lastTriggeredEpoch, "twitter");

      if (elapsedTime.length < 4 && elapsedTime.includes("s")) {
        elapsedTime = "Just now";
      } else if (elapsedTime.length <= 3) {
        return elapsedTime + " ago";
      }

      return elapsedTime;
    },
    removeUnsavedTypes() {
      this.alertTypes = this.alertTypes.filter((type) => !type.unsaved);
    },
    finishInitialLoad() {
      if (!this.loadingAlertTypes && !this.loadingAlertStatistics) {
        this.initialLoad = false;
      }
    },
    fetchTWNotifications(
        extraParams = null,
        alertToFocusOn = null,
        scrollTop = true,
        forceRerenderPagination = false,
        alertCardToUpdate = null,
        hightlightAlert = false
    ) {
      // alertCardTitle = null
      let params = {
        page: this.page - 1,
        size: this.itemsPerPage,
        minified: false,
      };
      if (extraParams != null) {
        params = Object.assign(params, extraParams);
      } else {
        params = Object.assign(params, this.getHistoryFetchParams());
      }
      TradeWatcherService.Alerts.query({params: params})
          .then((response) => {
            if (!this.lazyLoadAlertCards && !hightlightAlert) {
              // If you aren't highlighting an alert - then turn on the lazy load (since not all alert-cards need to be rendered right away)
              this.lazyLoadAlertCards = true;
            }

            if (this.alertsCountChanged) {
              this.$emit("update-alerts-total", response.data.totalElements);
              this.alertsCountChanged = false;
            }

            let rerender = this.totalHistoryPages !== response.data.totalPages;
            this.totalHistoryPages = response.data.totalPages;
            if (rerender || forceRerenderPagination) {
              this.rerenderPaginationComponent();
            }

            if (!response.data.empty) {
              this.alertHistory = this.parseAlertsData(response.data.content);

              if (scrollTop) {
                let element = document.getElementById("alert-cards-wrapper");
                if (element && element.scrollTop > 0) {
                  element.scrollTo(0, 0);
                }
              }
            } else {
              this.alertHistory = [];
            }

            if (alertCardToUpdate) {
              let card = this.alertDrawerCards.find(
                  (el) =>
                      el.alertStatistics.alertCardId === alertCardToUpdate.alertCardId
              );

              if (card)
                card.alertStatistics.totalAlerts = response.data.totalElements;
            }

            this.loadingAlertHistory = false;

            if (alertToFocusOn) {
              this.focusOnDomItem(alertToFocusOn);
            }

            // this.rerenderAlertsDrawerComponent()
          })
          .catch((error) => {
            console.error(error);
            this.loadingAlertHistory = false;
            this.$notifier.error("Couldn't fetch the latest alerts", {
              error: error,
            });
          });
    },
    alertCardAction(alertCard, action) {
      let id = alertCard.alertStatistics.alertCardId;
      let params;
      // console.log('alertCardAction alertCard', alertCard);
      // console.log('alertCardAction action', action);
      switch (action) {
        case this.ALERT_CARD_ACTIONS.ENABLE:
          params = {enabled: true};
          break;
        case this.ALERT_CARD_ACTIONS.DISABLE:
          params = {enabled: false};
          break;
      }
      TradeWatcherService.AlertCards.put(id, params)
          .then((response) => {
            this.fetchAlertStatistics();
            switch (action) {
              case this.ALERT_CARD_ACTIONS.ENABLE:
                this.$notifier.success(
                    `Alert card '${alertCard.alertStatistics.name}' enabled`
                );
                break;
              case this.ALERT_CARD_ACTIONS.DISABLE:
                this.$notifier.success(
                    `Alert card '${alertCard.alertStatistics.name}' disabled`
                );
                break;
            }
          })
          .catch((error) => {
            this.fetchAlertStatistics();
            if (action === this.ALERT_CARD_ACTIONS.ENABLE) {
              alertCard.enabled = false;
              this.$notifier.error("Couldn't enable the alert card", {
                error: error,
              });
            } else if (action === this.ALERT_CARD_ACTIONS.DISABLE) {
              alertCard.enabled = true;
              this.$notifier.error("Couldn't disable the alert card", {
                error: error,
              });
            }
          });
    },
    getComputerReadableDaysOfWeek(HRTiming) {
      let daysOfWeek = [];

      Object.keys(TWDaysAndTiming).forEach((dayName) => {
        let day = {};

        if (!HRTiming[dayName].value) {
          day.from = 0;
          day.to = 0;
        } else {
          day.from =
              HRTiming[dayName].time.from.hours * 3600 +
              HRTiming[dayName].time.from.minutes * 60;
          day.to =
              HRTiming[dayName].time.to.hours * 3600 +
              HRTiming[dayName].time.to.minutes * 60;

          if (HRTiming[dayName].time.from.dayPeriod === "pm") {
            day.from += 43200;
          }
          if (HRTiming[dayName].time.to.dayPeriod === "pm") {
            day.to += 43200;
          }

          if (day.to === 0 && HRTiming[dayName].value) {
            // Full selected day = from 0 to 86400. Deselected day = from 0 to 0
            day.to = 86400;
          }
        }

        day.timezone_offset = 0;

        if (dayName !== "sun") daysOfWeek.push(day);
        else daysOfWeek.unshift(day);
      });

      return daysOfWeek;
    },
    getHRTime(timeInSec) {
      let HRTime = {}; // Human Readable Time
      HRTime.hours = Math.trunc(timeInSec / 3600);
      HRTime.minutes = Math.trunc((timeInSec - HRTime.hours * 3600) / 60);
      HRTime.dayPeriod = HRTime.hours < 12 ? "am" : "pm";

      if (
          HRTime.dayPeriod === "pm" &&
          HRTime.hours === 24 &&
          HRTime.minutes === 0
      ) {
        HRTime.dayPeriod = "am";
        HRTime.hours = 0;
      } else if (HRTime.dayPeriod === "pm") {
        HRTime.hours = HRTime.hours - 12;
      }

      return HRTime;
    },
    getHumanReadableDaysOfWeek(cardSessions) {
      let daysOfWeek = {};

      let dayNames = Object.keys(TWDaysAndTiming);

      for (let i = 1; i < 7; i++) {
        // Starting from 1 (monday)
        let day = {value: cardSessions[i].to > 0, time: {}};

        day.time.from = this.getHRTime(cardSessions[i].from); // Human Readable Time Object
        day.time.to = this.getHRTime(cardSessions[i].to);

        daysOfWeek[dayNames[i - 1]] = day;
      }

      let day = {value: cardSessions[0].to > 0, time: {}};

      day.time.from = this.getHRTime(cardSessions[0].from);
      day.time.to = this.getHRTime(cardSessions[0].to);

      daysOfWeek.sun = day; // Add last day (sunday)

      return daysOfWeek;
    },
    fetchAlertStatistics(
        updateAlertsDrawer = true,
        updateDrawerAlertsLength = false,
        alertCardIdToUpdate = null
    ) {
      TradeWatcherService.AlertStatistics.query({
        params: {status: "all"},
      })
          .then((response) => {
            this.totalAlerts = response.data.total;

            if (this.initialLoad) this.finishInitialLoad();

            let alerts = response.data.alerts;

            this.alertCards = alerts.map((el) => {
              // Calculate lastTriggered
              let lastTriggeredHR = this.getHRDate(
                  el.alertStatistics.lastTriggered
              );

              if (el.alertStatistics.lastMessage !== "N/A") {
                let date = new Date(el.alertStatistics.lastTriggered);
                let cardDate = `${date.getDate()}/${
                    date.getMonth() + 1
                }/${date.getFullYear()}`;

                el.alertStatistics.cardDate = cardDate;
              } else el.alertStatistics.cardDate = "";

              el.alertStatistics.lastTriggeredHR = lastTriggeredHR;
              return el;
            });

            if (updateAlertsDrawer) {
              this.alertDrawerCards = JSON.parse(JSON.stringify(alerts)).map(
                  (el) => {
                    el.hovered = false;
                    return el;
                  }
              );
            }

            if (updateDrawerAlertsLength && alertCardIdToUpdate) {
              let alert = response.data.alerts.find((el) => {
                return el.alertStatistics.alertCardId === alertCardIdToUpdate;
              });
              let newTotals = null;
              if (alert) newTotals = alert.alertStatistics.totalAlerts;

              let card = this.alertDrawerCards.find(
                  (el) => el.alertStatistics.alertCardId === alertCardIdToUpdate
              );
              if (card && newTotals != null) {
                card.alertStatistics.totalAlerts = newTotals;
              }
            }

            this.loadingAlertStatistics = false;
          })
          .catch((error) => {
            this.loadingAlertStatistics = false;
            if (this.initialLoad) this.finishInitialLoad();
            this.$notifier.error("Couldn't fetch alert statistics", {
              error: error,
            });
          });
    },
    formatQuery(initial = false) {
      // initial is when opening the query editor
      let formattedQuery;
      try {
        formattedQuery = formatSql(
            initial ? this.alertTypeEditing.query : this.formattedQuery,
            isNaN(this.querySpaces) ? 3 : this.querySpaces
        );
      } catch (error) {
        console.error(error);
        formattedQuery = initial
            ? this.alertTypeEditing.query
            : this.formattedQuery;
        this.$notifier.warn("Couldn't format the query");
      }
      this.formattedQuery = formattedQuery;
    },
    updateUnsavedRenderKey() {
      this.unsavedMsgRenderKey > 2
          ? (this.unsavedMsgRenderKey = 0)
          : this.unsavedMsgRenderKey++;
    },
    updateMessageFormat() {
      let domElement = document.getElementById("alert-appearance-text");
      if (domElement != null)
        this.alertTypeEditing.message.format = domElement.textContent;
    },
    parseStringIntoArray(str, parseInteger = false) {
      let newArray = str.split(",");

      if (parseInteger) return newArray.map((el) => parseInt(el, 10));
      else return newArray;
    },
    parseStringAndNumArrays() {
      let fields = ["columnNames", "columnNumbers"];
      let message = this.alertTypeEditing.message;

      for (let i in fields) {
        let field = fields[i];
        if (typeof message[field] == "string") {
          message[field] = this.parseStringIntoArray(
              message[field],
              field === "columnNumbers"
          );
        }

        if (field === "columnNumbers") {
          message[field] = message[field].filter((num) => {
            return !(num == null || isNaN(num));
          });
        }
      }
    },
    acceptQueryFormat() {
      this.alertTypeEditing.query = this.formattedQuery;
      this.queryDialog = !this.queryDialog;
    },
    openQueryDialog() {
      this.formatQuery(true);
      this.queryDialog = !this.queryDialog;
    },
    /**
     * Handle the filter option selection
     * and trigger the history results display
     * @param filterValue {string} - the value of the filter option (also the object key) to check against
     */
    changeHistoryFilter(filterValue) {
      /* Check if the option selection is different from the current filter */
      if (this.historyFilter !== filterValue) {
        /* Perform filter option selection changes */
        this.filters[this.historyFilter].checked = false;
        this.historyFilter = this.filters[filterValue].value;
        this.filters[filterValue].checked = true;
      }
      this.paginationChangeHandler(1, true);
    },
    refreshCssView() {
      if (this.alertContainerClass === "simple-slow-opacityAN") {
        this.alertContainerClass = "simple-slow-opacityTW";
      } else {
        this.alertContainerClass = "simple-slow-opacityAN";
      }
    },
    showAllHistory() {
      this.selectedCard = null;
      this.showingAllHistory = true;
      if (!this.showHistory) this.showHistory = true;
      if (!this.twTabs) this.twTabs = 1;
      let params = this.getHistoryFetchParams({
        page: 0,
        size: this.itemsPerPage,
      });
      this.page = 1;
      this.fetchTWNotifications(params);
      this.refreshCssView();
    },
    switchTab(tabClicked) {
      this.page = 1;
      this.refreshCssView();
      if (this.twTabs === 1) {
        if (tabClicked !== 1) {
          this.selectedCard = null;
          this.showHistory = !this.showHistory;
          this.twTabs = 0;
        }
      } else {
        this.loadingAlertHistory = true;
        let params = this.getHistoryFetchParams({page: 0});
        this.fetchTWNotifications(params);
        if (tabClicked !== 0) {
          this.showHistory = !this.showHistory;
          this.twTabs = 1;
        }
      }
    },
    cardSelected(alertCardInfo, historyCardToFocusOn = null) {
      if (
          this.selectedCard == null ||
          this.selectedCard.id !== alertCardInfo.id ||
          historyCardToFocusOn != null
      ) {
        this.selectedCard = alertCardInfo;
        this.showingAllHistory = false;
        // Means card was selected from TW page and not notif. panel
        let params;

        if (historyCardToFocusOn == null) {
          params = this.getHistoryFetchParams({
            page: 0,
            size: this.itemsPerPage,
          });
          this.page = 1;
        } else {
          let page = Math.trunc(historyCardToFocusOn.index / this.itemsPerPage);

          params = this.getHistoryFetchParams({
            page: page,
            size: this.itemsPerPage,
          });
          this.page = page + 1;
        }

        this.fetchTWNotifications(
            params,
            historyCardToFocusOn != null ? historyCardToFocusOn.id : null
        );
      }
      this.showHistory = true;
      this.twTabs = 1;
    },
    getAlertDrawerValue(hover) {
      if (this.alertDrawerClipped && this.$vuetify.breakpoint.mdAndUp) {
        return true;
      } else {
        let val =
            this.$vuetify.breakpoint.smAndDown || this.isNotDesktop
                ? this.issuesDrawer
                : hover;
        return val;
      }
    },
    saveAlertTypeHandler() {
      this.alertTypeActionLoading = true;
      this.parseStringAndNumArrays();
      this.updateMessageFormat();
      if (!this.editingAlertType && this.addingNewAlertType)
        this.postAlertType();
      else {
        this.editAlertTypeRemote();
      }
    },
    editAlertType(type) {
      if (this.showNoArgsError) this.showNoArgsError = false;

      if (this.alertTypeEditing != null) this.updateMessageFormat();

      this.addingAlertType = false;
      this.editingAlertType = true;
      this.selectedATArgument = {};
      this.selectAlertType(type);
    },
    editAlertTypeRemote() {
      this.alertTypeActionLoading = true;
      // let newType = JSON.parse(JSON.stringify(this.alertTypeEditing));
      let newType = cloneDeep(this.alertTypeEditing);
      const newTypeArgumentsBuffer = cloneDeep(newType["arguments"]);
      newType["arguments"] = newTypeArgumentsBuffer.map((arg) => {
        delete arg.id;
        return arg;
      });

      newType.message.format = this.removeExtraSpacesFromMessage(
          newType.message.format
      );

      let id = newType.id;
      delete newType.id;
      TradeWatcherService.AlertTypes.put(id, newType)
          .then(() => {
            this.getAlertTypes();
            this.$notifier.success(`Alert type '${newType.name}' was saved!`);
            this.hasChanges = false;
          })
          .catch((error) => {
            this.$notifier.error("Couldn't save alert type", {error: error});
          });
      this.alertTypeActionLoading = false;
    },
    postAlertType() {
      let newType = JSON.parse(JSON.stringify(this.alertTypeEditing));
      newType.arguments = newType.arguments.map((arg) => {
        delete arg.id;
        return arg;
      });

      newType.message.format = this.removeExtraSpacesFromMessage(
          newType.message.format
      );

      delete newType.id;
      delete newType.unsaved;
      delete this.alertTypeEditing.unsaved; // unsaved is the only prop that needs to be deleted on alertTypeEditing as well as on the type that will be posted
      this.updateUnsavedRenderKey();

      TradeWatcherService.AlertTypes.post(newType)
          .then(() => {
            this.getAlertTypes(false, false, true);
            this.$notifier.success(`Alert type '${newType.name}' was saved!`);
            this.hasChanges = false;
          })
          .catch((error) => {
            console.error(error);
            this.alertTypeEditing.unsaved = true;
            this.updateUnsavedRenderKey();
            this.$notifier.error("Couldn't save alert type.", {error: error});
          });
      this.alertTypeActionLoading = false;
    },
    addAlertType() {
      if (this.showNoArgsError) this.showNoArgsError = false;

      this.editingAlertType = false;
      this.addingAlertType = true;
      let newType = Object.assign({}, defaultAlertTWType);
      newType.unsaved = true;
      let maxId = null;
      if (this.alertTypes.length) {
        this.alertTypes.forEach((el) => {
          if (maxId == null) maxId = el.id;
          else if (maxId < el.id) maxId = el.id;
        });
        newType.id = maxId + 1;
      } else {
        maxId = -1;
        newType.id = 0;
      }
      this.alertTypes.push(newType);
      this.selectAlertType(this.alertTypes.find((el) => el.id === maxId + 1));

      this.selectedATArgument = {};
    },
    deleteAlertType(alertType) {
      let id = alertType.id;
      let name = alertType.name;

      if (alertType.hasOwnProperty("unsaved") && alertType.unsaved) {
        this.alertTypes = this.alertTypes.filter((el) => el.id !== id);
        this.editAlertType(
            JSON.parse(
                JSON.stringify(this.alertTypes[this.alertTypes.length - 1])
            )
        );
      } else {
        TradeWatcherService.AlertTypes.delete(id)
            .then(() => {
              this.getAlertTypes();
              this.$notifier.success(`Alert ${name} deleted!`);
            })
            .catch((error) => {
              console.error(error);
              this.$notifier.error(`Couldn't delete alert ${name}!`, {
                error: error,
              });
            });
      }
    },
    deleteATArgument() {
      this.alertTypeEditing.arguments = this.alertTypeEditing.arguments.filter(
          (el) => el.id !== this.selectedATArgument.id
      );
      let maxIdItem = {id: -999};
      this.alertTypeEditing.arguments.forEach((el) => {
        if (el.id > maxIdItem.id) maxIdItem = el;
      });
      this.selectedATArgument = maxIdItem;
    },
    selectAlertType(alertType) {
      // console.log('selectAlertType', alertType);
      this.alertTypeEditing = Object.assign(alertType, {
        arguments: alertType.arguments.map((arg, i) => {
          arg.id = i;
          return arg;
        }),
      });
      if (this.alertTypeEditing.unsaved) {
        this.editingAlertType = false;
        this.addingNewAlertType = true;
      } else {
        this.addingNewAlertType = false;
        this.editingAlertType = true;
      }
    },
    addNewMetricArgument() {
      this.alertTypeEditing.arguments.push({
        name: "",
        friendlyName: "New Argument",
        id: this.alertTypeEditing.arguments.length
            ? this.alertTypeEditing.arguments[
        this.alertTypeEditing.arguments.length - 1
            ].id + 1
            : 0,
      });
    },
    getAlertTypes(
        twAdminDialog,
        focusOnFirstItem = false,
        focusSelected = false
    ) {
      if (twAdminDialog) {
        // Open 'Configure alert types dialog'
        this.addingNewAlertType = false;
        this.editingAlertType = true;
        this.twAdminDialog = true;
      }
      TradeWatcherService.AlertTypes.get()
          .then((r) => {
            // console.log('getAlertTypes res', r);
            this.loadingAlertTypes = false;
            // console.log('is initial load', this.initialLoad);
            if (this.initialLoad) this.finishInitialLoad();

            this.alertTypes = r.data;
            if (r.data.length && focusOnFirstItem)
              this.selectAlertType(this.alertTypes[0]);
            if (r.data.length && focusSelected) {
              let selectedItem = this.alertTypes.find(
                  (el) => el.name === this.alertTypeEditing.name
              );
              this.selectAlertType(selectedItem); // Needs to be selected again because after saving remotely, the ID may change
            }
          })
          .catch((error) => {
            console.error(error);
            this.loadingAlertTypes = false;
            if (this.initialLoad) this.finishInitialLoad();
            this.$notifier.error("Couldn't fetch alert types", {error: error});
          });
    },
    keyPressed(e) {
      if (e.keyCode === 13) {
        this.$refs.newAlertForm.$children[1].focus();
        this.$refs.newAlertForm.$children[1].activateMenu();
      }
    },
    editAlertTime(day) {
      this.currentDayEditing = day;
      let i;

      let scrollingLoop = setInterval(() => {
        i++;
        let element = document.getElementById("top-scrolls");
        if (element) {
          element.scroll(0, 3000);
          clearInterval(scrollingLoop);
        } else if (i > 50) {
          clearInterval(scrollingLoop);
        }
      }, 50);
    },
    saveAlertCardEdit() {
      let params = JSON.parse(JSON.stringify(this.currentEditIssue));
      let alertTypeArgsNames = Object.keys(params.alertType.arguments);

      if (Object.keys(params.arguments).length || params.arguments.length) {
        let stringsToParse = alertTypeArgsNames.filter((name) => {
          let args = params.alertType.arguments;
          let isNumArray = args[name].type === "array (number)";
          let isStringArray = args[name].type === "array (string)";
          let valueTypeOfString =
              typeof params.arguments[name].value == "string";

          return (isNumArray || isStringArray) && valueTypeOfString;
        });

        stringsToParse.forEach((argName) => {
          params.arguments[argName].value = this.parseStringIntoArray(
              params.arguments[argName].value,
              params.alertType.arguments[argName].type === "array (number)"
          ); // if it should be strictly an array of numbers then pass true in 2nd argument
        });
        Object.keys(params.arguments).forEach((argName) => {
          params.arguments[argName] = params.arguments[argName].value;
        });
      } else {
        params.arguments = {};
      }

      params.cardSessions = this.getComputerReadableDaysOfWeek(
          params.daysOfWeek
      );

      if (params.sourceIds.length) {
        params.arguments.sourceIds = JSON.parse(
            JSON.stringify(params.sourceIds)
        );
      }

      delete params.sourceIds;
      delete params.id;
      delete params.alertType;
      delete params.daysOfWeek;
      delete params.hovered;
      // delete params["specifications"];
      // console.log('params !@!@@@@@@!@!@@!@@@');
      // console.log(params);

      TradeWatcherService.AlertCards.put(this.currentEditIssue.id, params)
          .then(() => {
            this.dialog = false;
            this.fetchAlertStatistics(); // refresh alert cards
            this.$notifier.success(`Alert '${params.name}' edited!`);
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error(`Couldn't edit ${params.name}`, {
              error: error,
            });
          });
    },

    saveAlertCard() {
      let formatedArgs = JSON.parse(JSON.stringify(this.newAlert.arguments));

      Object.keys(formatedArgs).forEach((argName) => {
        formatedArgs[argName] = formatedArgs[argName].value;
      });

      let params = {
        name: this.newAlert.name,
        arguments: formatedArgs,
        notificationType: this.newAlert.notificationType,
        cardSessions: this.getComputerReadableDaysOfWeek(
            this.newAlert.daysOfWeek
        ),
        description: this.newAlert.description,
        specifications: this.newAlert.specifications,
      };

      if (this.newAlert.specifications.dynamicThreshold === null) {
        params.specifications.dynamicThreshold = defaultDynamicThreshold;
      }

      let stringsToParse = this.selectedAlertType.arguments.filter(
          (arg) =>
              (arg.type === "array (string)" || arg.type === "array (number)") &&
              typeof params.arguments[arg.name] == "string"
      );

      stringsToParse.forEach((str) => {
        params.arguments[str.name] = this.parseStringIntoArray(
            params.arguments[str.name],
            str.type === "array (number)"
        ); // if it should be strictly an array of numbers then pass true in 2nd argument
      });

      params.alertType = {id: this.selectedAlertType.id};

      if (this.newAlert.sourceIds.length) {
        params.arguments.sourceIds = JSON.parse(
            JSON.stringify(this.newAlert.sourceIds)
        );
      }

      // params.notificationType = null

      TradeWatcherService.AlertCards.post(params)
          .then(() => {
            this.dialog = false;
            this.fetchAlertStatistics(); // refresh alert cards
            this.$notifier.success(`Alert '${this.newAlert.name}' saved!`);
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error(`Couldn't save ${this.newAlert.name}`, {
              error: error,
            });
          });
    },
    confirmDelete(id, name) {
      this.alertCardDelitingId = id;
      this.alertCardDelitingName = name;
      this.confirmDialog = true;
    },
    deleteAlertCard() {
      TradeWatcherService.AlertCards.delete(this.alertCardDelitingId)
          .then(() => {
            if (this.showHistory) this.showHistory = false;
            if (this.twTabs !== 0) this.twTabs = 0;
            this.confirmDialog = false;
            this.fetchAlertStatistics(); // refresh alert cards
            this.$emit("update-alerts-total");
            this.$notifier.success(
                `Alert card '${this.alertCardDelitingName}' deleted!`
            );
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error(
                `Couldn't delete '${this.alertCardDelitingName}'`,
                {error: error}
            );
          });
    },
    clearDialogResources() {
      this.wizard = 1;
      this.wizardBacked = false;
      this.selectedAlertType = {};
      this.currentDayEditing = "";
      this.newAlert = JSON.parse(JSON.stringify(defaultAlertCard));
      this.$refs.newAlertForm.resetValidation();
    },
    validateForm() {
      switch (this.wizard) {
        case 1:
          this.$refs.newAlertForm.validate();
          break;
        case 2:
          this.$refs.TWForm2.validate();
          break;
        case 3:
          this.$refs.TWForm3.validate();
          break;
      }
    },
    updateVue() {
      this.$forceUpdate();
    },
    getDayTime(day) {
      let total;
      let time = this[this.getAlertPropName].daysOfWeek[day].time;
      let fromHours = time.from.hours;
      let toHours = time.to.hours;
      if (fromHours + toHours === 0) {
        total = "24h";
      } else if (time.from.dayPeriod !== time.to.dayPeriod) {
        total = Math.abs(fromHours - toHours) + 12 + "h";
      } else {
        if (fromHours >= toHours) {
          total = Math.abs(fromHours - toHours - 24) + "h";
        } else {
          total = Math.abs(fromHours - toHours) + "h";
        }
      }
      return total;
    },
    timeChanged(value, timeDirection, metricUnit) {
      if (metricUnit === "hours") {
        this.$nextTick(() => {
          if (value < this.minHour)
            this.newAlert.daysOfWeek[this.currentDayEditing].time[
                timeDirection
                ][metricUnit] = this.minHour;
          if (value > this.maxHour) {
            this.newAlert.daysOfWeek[this.currentDayEditing].time[
                timeDirection
                ][metricUnit] = this.maxHour;
          }
          this.rerenderDayTime();
        });
      } else {
        this.$nextTick(() => {
          if (value < this.minMinute)
            this.newAlert.daysOfWeek[this.currentDayEditing].time[
                timeDirection
                ][metricUnit] = this.minMinute;
          if (value > this.maxMinute) {
            this.newAlert.daysOfWeek[this.currentDayEditing].time[
                timeDirection
                ][metricUnit] = this.maxMinute;
          }
          this.rerenderDayTime();
        });
      }
    },
    selectDayOfWeekEditing(day) {
      this.currentEditIssue.daysOfWeek[day].value =
          !this.currentEditIssue.daysOfWeek[day].value;
      this.daysSelectorRenderKey > 2
          ? (this.daysSelectorRenderKey = 0)
          : this.daysSelectorRenderKey++;
    },
    selectDay(day) {
      if (this.edit) {
      } else if (
          Object.entries(this.newAlert.daysOfWeek).some((el) => {
            return el[1].value && el[0] !== day;
          })
      )
        this.newAlert.daysOfWeek[day].value =
            !this.newAlert.daysOfWeek[day].value;
    },
    forceTwoDigits(num) {
      return (num < 10 ? "0" : "") + num;
    },
    wizardBack() {
      this.wizard--;
      // wizardBacked is used to see if the user went to a previous step
      this.wizardBacked = true;
    },
    wizardContinue() {
      if (this.wizard < 3) {
        if (this.wizard === 1) {
          // This block of code adds the properties to newAlert object that are needed in the next step of wizard
          // This will happen only if the user is moving from step 1 to step 2 and newAlert.name is not empty

          let settings = {};
          if (!this.newAlert.arguments) {
            this.newAlert.arguments = {};
          }
          this.selectedAlertType.arguments.forEach((argument) => {
            switch (argument.type) {
              case "number":
              case "double":
                settings[argument.name] = this.newAlert.arguments[
                    argument.name
                    ] || {customValue: false, value: 0};
                break;
              case "array (string)":
              case "array (number)":
                settings[argument.name] = this.newAlert.arguments[
                    argument.name
                    ] || {customValue: false, value: []};
                break;
              case "boolean":
                settings[argument.name] = this.newAlert.arguments[
                    argument.name
                    ] || {customValue: false, value: false};
                break;
              default:
                settings[argument.name] = this.newAlert.arguments[
                    argument.name
                    ] || {customValue: false, value: ""};
            }
          });
          this.newAlert.arguments = settings;
          this.wizard++;
        } else {
          this.wizard++;
        }
      }
      // if (this.wizard === 3) {
      //   let notificationType = this.newAlert.notificationType;
      //   let hasChangeLevelType = !!this.newAlert.specifications.dynamicThreshold && !!this.newAlert.specifications.dynamicThreshold.changeLevelType && (this.newAlert.specifications.dynamicThreshold.changeLevelType.length > 0);
      //   // console.log(`is "CONTINUOUS type: ${notificationType === "CONTINUOUS"}. has changeLevelType: ${hasChangeLevelType}`);
      //   if (notificationType === "CONTINUOUS") {
      //     this.canSave = hasChangeLevelType;
      //   }
      // }
      if (this.wizardBacked) this.wizardBacked = false;
    },
    createAlert() {
      this.fetchDefinitions();
      this.getAlertTypes();
      this.edit = false;
      this.dialog = !this.dialog;
      if (this.$refs.newAlertForm) {
        this.$refs.newAlertForm.resetValidation();
      }
    },
    editAlertIssue(issue) {
      this.getAlertCardById(issue.alertStatistics.alertCardId)
          .then((response) => {
            // console.log('editAlertIssue response', response);
            this.preprocessAndOpenEditDialog(response.data);
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error("Couldn't edit the alert card", {
              error: error,
            });
          });
    },
    /**
     * Handle the dismissal of the Alert editor modal
     * - check if the editor is in edit mode and reset local variables
     * accordingly
     */
    closeAlertEditor() {
      this.dialog = false;
      if (this.edit === true) {
        this.currentEditIssue = {
          daysOfWeek: JSON.parse(JSON.stringify(TWDaysAndTiming)),
          importance: 2,
        };
      }
      this.newAlert.specifications.dynamicThreshold = null;
    },
    showAlertCardActions(index) {
      this.alertDrawerCards[index].hovered = true;
    },
    hideAlertCardActions(index) {
      this.alertDrawerCards[index].hovered = false;
    },
    closeAlertTypeEditor() {
      this.twAdminDialog = false;
      this.hasChanges = false;
    },
    checkSaveThresholdEligibility() {
      if ((this.newAlert.notificationType === 'CONTINUOUS') && !this.edit) {
        this.$refs.specificationsPanel.$refs.changeLevelTypeInputRef[0].validate(true);
      }
    },
    /**
     * Toggle between dense and free alert cards display
     * @param denseGridValue {Boolean} - specifies if the display will be dense or free
     */
    toggleDenseGrid(denseGridValue) {
      const updatedSettings = cloneDeep(this.getSettings);
      // console.log('updatedSettings in update settings toggleDenseGrid function in TradeWatcher page', updatedSettings);
      updatedSettings.applicationState.tradewatcher.denseGrid = denseGridValue;
      let profileId = parseInt(
          localStorage.getItem("currentSettingsProfileId"),
          10
      );

      if (!profileId && profileId !== 0) {
        if (this.isAdmin)
            // console.log(
            //     "No profile ID found when updating the application state."
            // );
          return;
      }

      let requestStatus = "200";

      SettingsService.put(profileId, updatedSettings)
          .then(() => {
            const tradeWatcherConfiguration = this.getSpecificSetting({
              section: "applicationState",
              innerSection: "tradewatcher"
            });
            const updatedTradeWatcherState = {
              ...tradeWatcherConfiguration,
              denseGrid: denseGridValue
            };
            const updateOptions = {
              section: APP_STATE_SECTIONS.TRADEWATCHER,
              mutation: updatedTradeWatcherState
            };
            this.updateApplicationState(updateOptions);
          })
          .catch((error) => {
            if (
                error.hasOwnProperty("message") &&
                error.message.search("404") !== -1
            ) {
              requestStatus = "404";
              // Get the configuration for the current type of device
              return SettingsService.getMe({
                params: {
                  device:
                      localStorage.getItem("selected-device-type") || "Desktop",
                },
              });
              // return SettingsService.getMe({ params: { device: "Desktop" } })
            }
          })
          .then((response) => {
            if (requestStatus === "404" && response.data) {
              localStorage.setItem(
                  "currentSettingsProfileId",
                  response.data.id
              );

              this.updateAppSettingsRemotely({
                settings: updatedSettings,
                recursive: true,
              });
            }
          })
          .catch((error) => {
            if (
                error.hasOwnProperty("message") &&
                error.message.search("404") !== -1
            ) {
              this.postNewSetting(false, updatedSettings);
            }
          });
    },
  },
  props: {
    tradeWatcherMute: {
      type: Boolean,
      default: false,
    },
    windowSizeY: {
      type: Number,
      default: 0,
    },
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    confirmDialog(v) {
      // Reset confirm dialog variables
      if (!v) {
        setTimeout(() => {
          this.deletingHistory = false;
        }, 500);
      }
    },
    dialog(value) {
      if (!value) {
        setTimeout(() => {
          if (!this.edit) this.clearDialogResources();
          this.edit = false;
        }, 280);
      }
    },
    twAdminDialog(value) {
      if (!value) {
        this.removeUnsavedTypes();
        setTimeout(() => {
          this.formattedQuery = "";
          this.alertTypeTabs = 0;
          this.selectedATArgument = {};
        }, 200);
      }
    },
    queryDialog(value) {
      if (!value) {
        this.showFormatSettings = false;
      }
    },
  },
  created() {
    this.fetchDefinitions();
    let alertDrawerClipped = JSON.parse(
        localStorage.getItem("alertDrawerClipped")
    );

    if (alertDrawerClipped != null) {
      this.alertDrawerClipped = alertDrawerClipped;
    }
    TimeAgo.addLocale(en);
    this.timeAgo = new TimeAgo("en-US");
    this.loadingAlertStatistics = true;
    this.fetchAlertStatistics();
    this.loadingAlertTypes = true;
    this.getAlertTypes();
  },
  mounted() {
    const tradeWatcherConfiguration = this.getSpecificSetting({
      section: "applicationState",
      innerSection: "tradewatcher"
    });
    if (!tradeWatcherConfiguration.hasOwnProperty("denseGrid")) {
      // console.log('USER HAS NO DENSE GRID PREFERENCE SET');
      const updatedTradeWatcherState = {
        ...tradeWatcherConfiguration,
        denseGrid: false
      };
      const updateOptions = {
        section: APP_STATE_SECTIONS.TRADEWATCHER,
        mutation: updatedTradeWatcherState
      };
      this.updateApplicationState(updateOptions);
      // let updatedSettings = cloneDeep(this.getSettings);
      // console.log('updatedSettings in mounted check in trade watcher', updatedSettings);
      this.toggleDenseGrid(false);
    }

    timeUpdateInterval = setInterval(() => {
      this.updateCardsTime();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(timeUpdateInterval);
  },
};
</script>

<style scoped src="../css/utilities/scoped/tradeWatcher.css"></style>
<style src="../css/utilities/tradeWatcher.css"></style>
<style lang="scss" scoped>
.alert-card-wrap {
  max-width: 380px;
}
</style>
